import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import axios from "axios";
import "../../assets/scss/custom/pages/_email_custom.scss";
import {
  Row,
  Container,
  Col,
  Modal,
  Collapse,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Tooltip,
  UncontrolledTooltip,
  ModalBody,
  ModalFooter,
  Spinner
} from "reactstrap";
//Import Breadcrumb
// Import Images
import dots from "../../assets/images/more_horiz_black_20dp.png";
import {
  EditorState,
  convertFromRaw,
  ContentState,
  convertFromHTML,
  Modifier,
  convertToRaw,
  stateToHTML,
  draftToHtml
} from "draft-js";
import styled from "styled-components";
import EmailContent from "./components/EmailContent";

// import Editor, { Component } from "react";
import "draft-js-static-toolbar-plugin/lib/plugin.css";
import Editor, { createEditorStateWithText } from "draft-js-plugins-editor";
import createEmojiPlugin from "draft-js-emoji-plugin";
import "draft-js-emoji-plugin/lib/plugin.css";
import createToolbarPlugin, { Separator } from "draft-js-static-toolbar-plugin";
import { ItalicButton, BoldButton, UnderlineButton } from "draft-js-buttons";
import "./../E-mail/Editor/editor/customtoolbar.scss";
// Editor
import "./../E-mail/Editor/content/content.scss";
import aiButtonicon from "./../../assets/images/icons8-bot-48.png";
import logo_smartas_1 from "./../../assets/images/companies/img-3.png";
import CustomToast from "../../components/Common/customToast/CustomToast";
import { withTranslation } from "react-i18next";
import {
  copyMailPromise,
  createLog,
  sendMailPromise,
  updateCompanyTokenUsage,
  createAiTextImprovementFunctionExecution,
  createAIResponseExecution,
  translateWithDeepLPromise,
  moveMailPromise,
  fetchSingleMail,
  getLanguageVersion,
  getMailsDatas
} from "../../helpers/api_helper";
import DropDown from "./components/dropDown";
import Feedback from "../Settings/component/feedback";
import { Client, Account, Databases, Query } from "appwrite";
import getFrenchTag from "../../helpers/local_text_helper";

import love from "../../assets/images/love.gif";
import like from "../../assets/images/like.gif";
import hate from "../../assets/images/hate.gif";
import neutral from "../../assets/images/neutral.gif";
import InfoMono from "../../assets/images/icons/InfoMono";
import { fetchMailsRedux } from "../../store/actions";
import { useDispatch, useSelector } from "react-redux";
import AlertTriangeMono from "../../assets/images/icons/AlertTriangeMono";
import IconParkSolidRobotOne from "../../assets/images/icons/IconParkSolidRobotOne";
import { useMixpanel } from "../../Hooks/useMixpanel";

const emojiPlugin = createEmojiPlugin();
const { EmojiSuggestions, EmojiSelect } = emojiPlugin;

const toolbarPlugin = createToolbarPlugin();
const { Toolbar } = toolbarPlugin;
const plugins = [toolbarPlugin, emojiPlugin];
const text = "";

const ReadEmail = (props) => {
  document.title = props.t("Email") + " | Synibox - Smart Assistant";
  const [folderbtn, setfolderbtn] = useState(false);
  const [tagbtn, settagbtn] = useState(false);
  const [menubtn, setmenubtn] = useState(false);
  const [replyEmail, setIsReplyEmail] = useState(false);
  const [instruction_text, setInstructionText] = useState("");
  const [instruction_request, setInstructionRequestValue] = useState(false);
  const [send_email_request, setSendEmailRequestValue] = useState(false);
  const [email_suggested_text, setEmailSuggestedText] = useState("");
  const [modal_backdrop, setModalVisibility] = useState(false);
  const [the_related_messages, setRelatedMessages] = useState([]);
  const [error, setError] = useState(undefined);
  const [fullMessageLoading, setFullMessageLoading] = useState(true);
  const [request, setRequest] = useState(true);
  const [isExpanded, setIsExpanded] = useState({});
  const [moveToModal, setMoveToModal] = useState(false);
  const [ai_action_menu, setAiActionMenu] = useState(false);
  const [process_action_menu, setProcessActionMenu] = useState(false);
  // const [messageInfos, setMessageInfos] = useState({});
  const [messageTreatmentStatus, setMessageTreatmentStatus] = useState(false);
  const [tooltip, setTooltip] = useState(false);
  const [translatedMessages, setTranslatedMessages] = useState({});
  const [translatedMessagesLoading, setTranslatedMessagesLoading] = useState(
    {}
  );
  const lastFetchedMessageId = useRef(null);
  const isCancelled = useRef(false);
  // const [fullMessage, setFullMessage] = useState(undefined);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [isProcess, setIsProcess] = useState(false);
  const [loadingProcess, setLoadingProcess] = useState(false);
  const [messageToProcess, setMessageToProcess] = useState(undefined);

  const { mixPanelTrack } = useMixpanel();

  const textEndRef = useRef(null);
  const textEndRelateRef = useRef(null);

  const dispatch = useDispatch();

  let the_folder = props.folder;
  let message = props.the_message;

  let fullMessage = props.fullMessage;
  let messageInfos = props.messageInfos;
  // let sentMessage = props.sentMessage;
  const process_start_time = Date.now().toString();

  const handleFeedBackOpen = () => {
    setMoveToModal(true);
  };

  const [hoverText, setHoverText] = useState([]);

  const handleFeedbackClose = () => {
    setMoveToModal(false);
  };

  const handleToggle = (element) => {
    console.log("initial value: ", isExpanded);

    setIsExpanded((prevState) => ({
      ...prevState,
      [element]: prevState[element] ? undefined : element
    }));
    console.log("final value: ", isExpanded);
  };

  function htmlFirstPart(htmlString) {
    let startIndex = htmlString.indexOf('<div class="gmail_quote">');
    let startIndex2 = htmlString.indexOf('<div id="appendonsend">');

    if (startIndex !== -1) {
      let firstPart = htmlString.substring(0, startIndex);
      return firstPart;
    } else if (startIndex2 !== -1) {
      let firstPart = htmlString.substring(0, startIndex2);
      return firstPart;
    } else {
      // Si la balise <div class="gmail_quote"> n'est pas trouvée, retourner la chaîne d'origine
      console.log("no index found");
      return htmlString;
    }
  }

  function htmlSecondPart(htmlString) {
    let startIndex = htmlString.indexOf('<div class="gmail_quote">');
    let startIndex2 = htmlString.indexOf('<div id="appendonsend">');
    if (startIndex !== -1) {
      let secondPart = htmlString.substring(startIndex);
      return secondPart;
    } else if (startIndex2 !== -1) {
      let secondPart = htmlString.substring(startIndex2);
      return secondPart;
    } else {
      // Si la balise <div class="gmail_quote"> n'est pas trouvée, retourner la chaîne d'origine
      console.log("no index found");
      return htmlString;
    }
  }

  // const [editorState, setEditorState] = useState(EditorState.createEmpty());

  // fonction pour récupérer le contenu en texte simple
  const getText = () => {
    const contentState = customEditorState.getCurrentContent();
    const plainText = contentState.getPlainText();
    // console.log("text from editor is", plainText);
    return plainText;
  };

  // fonction pour récupérer le contenu en html
  const getHTML = () => {
    const contentState = customEditorState.getCurrentContent();
    const raw = convertToRaw(contentState);
    const markup = draftToHtml(raw);
    return markup;
  };
  function togModalVisibility() {
    setModalVisibility(!modal_backdrop);
  }
  // fonction pour ajouter du texte simple dans l'éditeur
  const addSimpleTextToEditor = async (email_suggested) => {
    console.log("email_suggested is", email_suggested);
    /*
    const contentState = ContentState.createFromText("");
    const newEditorState = EditorState.push(editorState, contentState);
    setEditorState(newEditorState);
    */
    // Effacer le contenu de l'éditeur
    // const newEditorState = EditorState.createEmpty();

    const characters = email_suggested.split("");
    const added_characters = [];
    let index = 0;
    let intervalId;

    intervalId = setInterval(() => {
      added_characters.push(characters[index]);

      /*
      const currentContentState = editorState.getCurrentContent();
      const currentSelectionState = editorState.getSelection();
      added_characters.push(characters[index]);
      // console.log("newText is", newText);
      const newContentState = Modifier.insertText(
        currentContentState,
        currentSelectionState,
        added_characters.join(""),
      );
      const updatedEditorState = EditorState.push(
        editorState,
        newContentState,
        'insert-characters',
      );
      */
      const contentState = ContentState.createFromText(
        added_characters.join("")
      );
      const newEditorState = EditorState.push(customEditorState, contentState);
      setCustomEditorState(newEditorState);
      // setEditorState(updatedEditorState);
      index++;

      if (index >= characters.length) {
        clearInterval(intervalId);
      }
    }, Math.floor(Math.random() * 30));
  };

  // fonction pour ajouter du texte en html dans l'éditeur
  const addHTMLTextToEditor = () => {
    const html = "<p><strong>Bonjour le monde !</strong></p>";
    const contentState = convertFromHTML(html);
    const newEditorState = EditorState.push(customEditorState, contentState);
    setCustomEditorState(newEditorState);
  };

  const onInstructionRequestChange = (value) => {
    setInstructionRequestValue(value);
  };
  const onSendEmailRequestChange = (value) => {
    setSendEmailRequestValue(value);
  };

  const onInstructionInputChange = (event) => {
    setInstructionText(event.target.value);
  };
  const updateEmailSuggestedText = (value) => {
    setEmailSuggestedText(value);
  };

  /*
  useEffect(() => {
    const message = props.the_message;
    const source = axios.CancelToken.source();

    console.log("props.alertList", props.alertList);

    if (message && message.directMessageId !== lastFetchedMessageId.current) {
      getSingleMailFull(message, source.token);
      lastFetchedMessageId.current = message.directMessageId;
    }

    return () => {
      source.cancel("Requête annulée en raison d'un changement de composant.");
    };
  }, [props.the_message, props.showReadEmailView]);


  const getSingleMailFull = async (message, cancelToken) => {
    setFullMessageLoading(true);
    // setFullMessage({});

    console.log("fetchSingleMail message is", message.subject);

    let fullMessagesList = localStorage.getItem(
      `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`
    );

    if (!fullMessagesList) {
      fullMessagesList = {};
    } else {
      fullMessagesList = JSON.parse(fullMessagesList);
    }
    console.log("fetchSingleMail length", Object.keys(fullMessagesList)?.length);

    if (fullMessagesList[message.directMessageId] && fullMessagesList[message.directMessageId] !== "waiting") {
      console.log("fetchSingleMail: mail exist", message.directMessageId, fullMessagesList[message.directMessageId], message.subject);
      setFullMessage(fullMessagesList);
      setFullMessageLoading(false);
      const fullMsg = fullMessagesList[message.directMessageId];
      props.fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);
    } else {
      fullMessagesList[message.directMessageId] = "waiting";
      setFullMessage(fullMessagesList);
    }

    try {
      const fullMail = await fetchSingleMail(message.directMessageId, client_data.$id, the_folder, cancelToken);
      // if (isCancelled.current) return;

      if (fullMail && fullMail.mails && fullMail.mails.length > 0) {
        console.log("fetchSingleMail Full mail for ===", { sub_1: message.subject, sub_2: fullMail.mails[0].subject });
        const fullMsg = fullMail.mails[0];
        props.fetchMessageOrders(fullMsg.related_messages ? [fullMsg, ...fullMsg.related_messages] : [fullMsg]);

        fullMessagesList[message.directMessageId] = fullMail.mails[0];
        setFullMessage(fullMessagesList);
        localStorage.setItem(
          `cached_full_messages_${localStorage.getItem("companyId")}_${localStorage.getItem("selected_mail_box")}`,
          JSON.stringify(fullMessagesList)
        );
        setFullMessageLoading(false);
      } else {
        fullMessagesList[message.directMessageId] = undefined;
        setFullMessage(fullMessagesList);
        setFullMessageLoading(false);
      }
    } catch (error) {
      // if (isCancelled.current) return;

      fullMessagesList[message.directMessageId] = undefined;
      setFullMessage(fullMessagesList);
      console.log("catch fetchSingleMail", error);
      setFullMessageLoading(false);
    }
  };
*/
  const handlesReplyEmail = () => {
    console.log("handlesReplyEmail");
    setIsReplyEmail(true);
    getAIResponse();
  };
  const onLoading = (val) => {
    setFullMessageLoading(val);
  };

  async function sendEmail() {
    onSendEmailRequestChange(true);

    const messageToReply = fullMessage
      ? !fullMessage[message.directMessageId].related_messages ||
        fullMessage[message.directMessageId].related_messages.length === 0
        ? fullMessage[message.directMessageId]
        : fullMessage[message.directMessageId].related_messages[
            fullMessage[message.directMessageId].related_messages.length - 1
          ]
      : undefined;

    let message_to_reply_id = "";
    if (typeof messageToReply.headers["message-id"] === "string") {
      message_to_reply_id = messageToReply.headers["message-id"];
    } else if (Array.isArray(messageToReply.headers["message-id"])) {
      // eslint-disable-next-line prefer-destructuring
      message_to_reply_id = messageToReply.headers["message-id"][0];
    }

    // axios
    //   .post(
    //     "https://mailbox.semecloud.tech/send-mail",
    //     // "http://localhost:55000/send-mail",
    //     {
    //       to: messageToReply.from.value[0].address,
    //       to_name: messageToReply.from.value[0].name,
    //       subject: messageToReply.subject,
    //       text: getText(),
    //       company_id: localStorage.getItem("companyId"),
    //       message_to_reply_references: messageToReply.headers.references,
    //       message_to_reply_id,
    //       message_to_reply: messageToReply.body.html ? messageToReply.body.html : messageToReply.body.textAsHtml,
    //     }
    //   )
    sendMailPromise(messageToReply, getText(), message_to_reply_id)
      .then(async (response) => {
        // Traiter les données de la réponse

        // await copyMail(message_to_reply_id, the_folder, "Treated");
        await updateMessageData(
          fullMessage[message.directMessageId],
          "Treated",
          process_start_time
        );

        if (props.client_data.move_treated_emails) {
          moveMailPromise(message_to_reply_id, "INBOX", "SMARTAS.Treated")
            .then(async (response) => {
              console.log("Msg moved", response);
            })
            .catch((error) => {
              // Handle the error
              console.log("Failed moving msg", error);
            });
        } else {
          copyMailPromise(message_to_reply_id, "INBOX", "SMARTAS.Treated")
            .then(async (response) => {
              console.log("Msg copied", response);
            })
            .catch((error) => {
              // Handle the error
              console.log("Failed coping msg", error);
            });
        }

        onSendEmailRequestChange(false);
        togModalVisibility();
        const jsonObject = {
          text: ""
        };
        const jsonString = JSON.stringify(jsonObject);

        addSimpleTextToEditor(JSON.parse(jsonString).text);

        dispatch(
          fetchMailsRedux(
            localStorage.getItem("companyId"),
            the_folder,
            1,
            20,
            []
          )
        );

        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        const company_id = localStorage.getItem("companyId");
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id,
          mail_id: messageToReply.messageId,
          is_ai: false,
          receiver: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
          subject: messageToReply.subject
        };
        let logdata = {
          event: "mail_reply",
          author_id: user_id,
          company_id,
          log_data: JSON.stringify(logData)
        };
        createLog(logdata, mixPanelTrack);
      })
      .catch((error) => {
        // Gérer l'erreur
        if (error.response) {
          // La requête a été reçue, mais le serveur a répondu avec un code d'erreur
          console.log(
            "// La requête a été reçue, mais le serveur a répondu avec un code d'erreur"
          );
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(
            "// La requête a été envoyée, mais aucune réponse n'a été reçue"
          );
          console.log(error.request);
        } else {
          console.log(
            "// Une erreur est survenue lors de la création de la requête"
          );
          console.log("Erreur", error.message);
        }
        console.log(error.config);
        onSendEmailRequestChange(false);
      });
  }

  const copyMail = async function (message_id, the_folder, destination_folder) {
    console.log("coping Mail");

    const apiUrl = "https://mailbox.semecloud.tech/copy-mail";
    // const apiUrl = "http://localhost:55000/copy-mail";
    const company_id = localStorage.getItem("companyId");
    // axios
    //   .post(
    //     apiUrl,
    //     {
    //       company_id,
    //       destination_folder: destination_folder,
    //       folder: the_folder,
    //       messageId: message_id,
    //     },

    //     {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     }
    //   )
    copyMailPromise(message_id, the_folder, destination_folder)
      .then(async (response) => {
        console.log("Msg copied", response);
      })
      .catch((error) => {
        // Handle the error
        console.log("Failed copying msg", error);
      });
  };
  const extractIPs = (the_data) => {
    const regex = /\[([^\]]+)\]/;
    const ips = [];
    the_data.forEach((entry) => {
      const matches = entry.match(regex);
      if (matches) {
        ips.push(matches[1]);
      }
    });
    return ips;
  };

  async function updateMessageData(theMessage, proccessed, process_start_time) {
    console.log(`Start saving message data for ${theMessage.messageId}`);

    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    try {
      let message_to_reply_id = "";
      if (typeof theMessage.headers["message-id"] === "string") {
        message_to_reply_id = theMessage.headers["message-id"];
      } else if (Array.isArray(theMessage.headers["message-id"])) {
        // eslint-disable-next-line prefer-destructuring
        message_to_reply_id = theMessage.headers["message-id"][0];
      }
      console.log(
        "message date is",
        new Date(theMessage.attributes.date).getTime().toString()
      );
      console.log("new date is", Date.now().toString());
      const response = await databases.updateDocument(
        "default",
        "message",
        message_to_reply_id,
        {
          message_process_date: process_start_time,
          message_process_end_date: Date.now().toString(),
          process_state: proccessed,
          treated_by_ia: false
        }
      );

      console.log(
        `Successfully updated message data for ${theMessage.messageId}`
      );
      return response.$id;
    } catch (error) {
      console.log(
        `Failed updating message data for ${theMessage.messageId}. Error is: ${error}`
      );
      // throw error;
      return null;
    }
  }

  /*
  const fetchRelatedMails = async function (data,) {

    console.log("folder for fetchRelatedMails request is", the_folder);
    onLoading(true);

    let messageId = '';
    if (typeof message.headers['message-id'] === 'string') {
      messageId = message.headers['message-id'];
    } else if (Array.isArray(message.headers['message-id'])) {
      // eslint-disable-next-line prefer-destructuring
      messageId = message.headers['message-id'][0];
    }
    console.log("messageId", message.headers['message-id']);
    //axios.get("http://localhost:55000/get-thread-messages", {
    axios.get("https://mailbox.semecloud.tech/get-thread-messages", {
      params: {
        folder: the_folder,
        messageId,
        company_id: data.$id
      },
    })
      .then((response) => {
        console.log("response.mails", response.mails);
        onLoading(false);
        setMessages(response.mails.reverse());

      })
      .catch((error) => {
        // Gérer l'erreur
        onLoading(false);
        console.log(JSON.stringify(error));
        setError(JSON.stringify(error));
      });

  }
  */

  function emptyTheWysiwyg() {
    const jsonObject = {
      text: ""
    };
    const jsonString = JSON.stringify(jsonObject);

    addSimpleTextToEditor(JSON.parse(jsonString).text);
  }

  async function getAIResponse() {
    const messageToReply =
      !fullMessage[message.directMessageId].related_messages ||
      fullMessage[message.directMessageId].related_messages.length === 0
        ? fullMessage[message.directMessageId]
        : fullMessage[message.directMessageId].related_messages[
            fullMessage[message.directMessageId].related_messages.length - 1
          ];

    console.log("getAIResponse called");
    console.log("input instruction is", instruction_text);
    console.log("messageToReply body is", messageToReply.body.text);

    onInstructionRequestChange(true);
    onSendEmailRequestChange(true);

    const response = await createAIResponseExecution(
      [
        {
          email_id: messageToReply.directMessageId,
          // email_subject: messageToReply.subject,
          email_body: messageToReply.body.textAsHtml
            ? messageToReply.body.textAsHtml
            : messageToReply.body.text,
          email_sender: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`
        }
      ],
      localStorage.getItem("companyId")
    );

    console.log({ createAIResponseExecution: response });

    if (response) {
      const data = response;
      console.log({ data });
      updateCompanyTokenUsage(
        data.token_email_response.prompt_tokens +
          data.token_analyse.prompt_tokens,
        data.token_email_response.completion_tokens +
          data.token_analyse.completion_tokens
      );

      console.log("messageToReply ", messageToReply.directMessageId);
      console.log(
        "text response is",
        data.result[messageToReply.directMessageId.replace(/^<|>$/g, "")]
          .mail_response
      );
      const jsonObject = {
        text: data.result[messageToReply.directMessageId.replace(/^<|>$/g, "")]
          .mail_response
      };
      const jsonString = JSON.stringify(jsonObject);

      addSimpleTextToEditor(JSON.parse(jsonString).text);
      onInstructionRequestChange(false);
      onSendEmailRequestChange(false);

      updateEmailSuggestedText(
        data.result[messageToReply.directMessageId.replace(/^<|>$/g, "")]
          .mail_response
      );

      props.incrementAttrByValue(1, "Email reply");

      // Créer le log
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
      const company_id = localStorage.getItem("companyId");
      let logData = {
        eventCreatedAt: Date.now(),
        author_id: user_id,
        company_id,
        mail_id: messageToReply.directMessageId,
        receiver: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
        subject: messageToReply.subject
      };
      let logdata = {
        event: "ia_autogen_request",
        author_id: user_id,
        company_id,
        log_data: JSON.stringify(logData)
      };
      createLog(logdata, mixPanelTrack);
    } else {
      const error =
        response && response.error && response.error.message
          ? response.error.message
          : "Erreur inattendue";
      console.log("Failed getting AIResponse", error);

      onInstructionRequestChange(false);
      onSendEmailRequestChange(false);
    }

    /*
    axios
      .post(
        "https://ai.semecloud.tech/email-reply",

        {
          emails: [
            {
              email_id: messageToReply.messageId,
              // email_subject: messageToReply.subject,
              email_body: messageToReply.body.textAsHtml ? messageToReply.body.textAsHtml : messageToReply.body.text,
              email_sender: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
            },
          ],
          company_id: localStorage.getItem("companyId"),
        },
      )
      .then((response) => {
        // Traiter les données de la réponse

        const data = response.result;
        updateCompanyTokenUsage(
          response.token_email_response.prompt_tokens + response.token_analyse.prompt_tokens,
          response.token_email_response.completion_tokens + response.token_analyse.completion_tokens,
        );

        console.log("instruction response is", data);

        console.log("text response is", data[messageToReply.messageId].mail_response);
        const jsonObject = {
          text: data[messageToReply.messageId].mail_response,
        };
        const jsonString = JSON.stringify(jsonObject);

        addSimpleTextToEditor(JSON.parse(jsonString).text);
        onInstructionRequestChange(false);
        onSendEmailRequestChange(false);

        updateEmailSuggestedText(data);
        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        const company_id = localStorage.getItem("companyId");
        let logData = {
          eventCreatedAt: Date.now(),
          author_id: user_id,
          company_id,
          mail_id: messageToReply.messageId,
          receiver: `${messageToReply.from.value[0].name} <${messageToReply.from.value[0].address}>`,
          subject: messageToReply.subject,
        };
        let logdata = {
          event: "ia_autogen_request",
          author_id: user_id,
          company_id,
          log_data: JSON.stringify(logData),
        };
        createLog(logdata, mixPanelTrack);
      })
      .catch((error) => {
        console.log("Failed getting AIResponse", error);
        // Gérer l'erreur
        if (error.response) {
          // La requête a été reçue, mais le serveur a répondu avec un code d'erreur
          console.log("// La requête a été reçue, mais le serveur a répondu avec un code d'erreur");
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log("// La requête a été envoyée, mais aucune réponse n'a été reçue");
          console.log(error.request);
        } else {
          console.log("// Une erreur est survenue lors de la création de la requête");
          console.log("Erreur", error.message);
        }
        console.log(error.config);
        onInstructionRequestChange(false);
        onSendEmailRequestChange(false);
      });
      */
  }

  async function getAiTextImprovement(theTask) {
    console.log("getAiTextImprovement called");
    // console.log("text to process is", getText());

    const messageToReply =
      !fullMessage[message.directMessageId].related_messages ||
      fullMessage[message.directMessageId].related_messages.length === 0
        ? fullMessage[message.directMessageId]
        : fullMessage[message.directMessageId].related_messages[
            fullMessage[message.directMessageId].related_messages.length - 1
          ];

    // let message_to_reply_id = "";
    // if (typeof messageToReply.headers["message-id"] === "string") {
    //   message_to_reply_id = messageToReply.headers["message-id"];
    // } else if (Array.isArray(messageToReply.headers["message-id"])) {
    //   message_to_reply_id = messageToReply.headers["message-id"][0];
    // }

    // const msg_language = messageInfos[message_to_reply_id].client_language;

    onInstructionRequestChange(true);
    onSendEmailRequestChange(true);

    const response = await createAiTextImprovementFunctionExecution({
      task: theTask,
      data: getText(),
      interlocutor_text:
        theTask === "translation"
          ? messageToReply.body.textAsHtml
            ? messageToReply.body.textAsHtml
            : messageToReply.body.text
          : undefined
    });
    console.log({ createAiTextImprovementFunctionExecution: response });

    if (response && response.responseBody) {
      //  updateCompanyTokenUsage(500, 2000);
      const data = JSON.parse(response.responseBody).ia_response;

      console.log("text response is", data);
      const jsonObject = {
        text: data
      };
      const jsonString = JSON.stringify(jsonObject);

      addSimpleTextToEditor(JSON.parse(jsonString).text);
      onInstructionRequestChange(false);
      onSendEmailRequestChange(false);

      updateEmailSuggestedText(data);

      var reason;
      switch (theTask) {
        case "styling":
          reason = "Text style improvement";
          break;
        case "translation":
          reason = "Text translation";
          break;
        case "grammar":
          reason = "Text style improvement";
          break;
        case "reduce":
          reason = "Text contraction";
          break;
        default:
          break;
      }
      props.incrementAttrByValue(0.25, reason);

      // Créer le log
      var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
      const company_id = localStorage.getItem("companyId");
      let logData = {
        eventCreatedAt: Date.now(),
        author_id: user_id,
        company_id
      };
      let logdata = {
        event: "ia_autogen_request",
        author_id: user_id,
        company_id,
        log_data: JSON.stringify(logData)
      };
      createLog(logdata, mixPanelTrack);
    } else {
      const error =
        response &&
        response.responseBody &&
        JSON.parse(response.responseBody).error &&
        JSON.parse(response.responseBody).error.message
          ? JSON.parse(response.responseBody).error.message
          : "Erreur inattendue";
      console.log("Failed getting AIResponse", error);

      onInstructionRequestChange(false);
      onSendEmailRequestChange(false);
    }

    // axios
    //   .post(
    //     "https://ai.semecloud.tech/text-generation",
    //     {
    //       task: theTask,
    //       data: getText(),
    //       destination_language: theTask === "translation" ? msg_language : undefined,
    //     },
    //   )
    //   .then((response) => {
    //     // Traiter les données de la réponse
    //     updateCompanyTokenUsage(500, 2000);
    //     const data = response.ia_response;

    //     console.log("text response is", data);
    //     const jsonObject = {
    //       text: data,
    //     };
    //     const jsonString = JSON.stringify(jsonObject);

    //     addSimpleTextToEditor(JSON.parse(jsonString).text);
    //     onInstructionRequestChange(false);
    //     onSendEmailRequestChange(false);

    //     updateEmailSuggestedText(data);
    //     // Créer le log
    //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    //     const company_id = localStorage.getItem("companyId");
    //     let logData = {
    //       eventCreatedAt: Date.now(),
    //       author_id: user_id,
    //       company_id,
    //     };
    //     let logdata = {
    //       event: "ia_autogen_request",
    //       author_id: user_id,
    //       company_id,
    //       log_data: JSON.stringify(logData),
    //     };
    //     createLog(logdata, mixPanelTrack);
    //   })
    //   .catch((error) => {
    //     console.log("Failed getting AIResponse", error);
    //     // Gérer l'erreur
    //     if (error.response) {
    //       // La requête a été reçue, mais le serveur a répondu avec un code d'erreur
    //       console.log("// La requête a été reçue, mais le serveur a répondu avec un code d'erreur");
    //       console.log(error.response.data);
    //       console.log(error.response.status);
    //       console.log(error.response.headers);
    //     } else if (error.request) {
    //       console.log("// La requête a été envoyée, mais aucune réponse n'a été reçue");
    //       console.log(error.request);
    //     } else {
    //       console.log("// Une erreur est survenue lors de la création de la requête");
    //       console.log("Erreur", error.message);
    //     }
    //     console.log(error.config);
    //     onInstructionRequestChange(false);
    //     onSendEmailRequestChange(false);
    //   });
  }

  async function getAIResponseDialogs(theMessage) {
    console.log("getAIResponse called");
    console.log("input instruction is", instruction_text);

    onInstructionRequestChange(true);
    onSendEmailRequestChange(true);

    axios
      .post(
        "https://ai.semecloud.tech/email-ia-dialog",
        // "http://localhost:3000/api/email-ia-dialog",
        {
          message: {
            email_instruction:
              instruction_text.length === 0 ? instruction_text : "",
            email_subject: theMessage.subject,
            email_body: theMessage.body.textAsHtml
              ? theMessage.body.textAsHtml
              : theMessage.body.text,
            email_sender: `${theMessage.from.value[0].name} <${theMessage.from.value[0].address}>`
          }
        }
        /*
      {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
          'Access-Control-Allow-Headers': 'X-CSRF-Token, X-Requested-With, Accept, Accept-Version, Content-Length, Content-MD5, Content-Type, Date, X-Api-Version'
        }
      }
      */
      )
      .then((response) => {
        // Traiter les données de la réponse

        const data = response.result;
        console.log("instruction response is", data);

        const jsonObject = {
          text: data
        };
        const jsonString = JSON.stringify(jsonObject);

        addSimpleTextToEditor(JSON.parse(jsonString).text);
        onInstructionRequestChange(false);
        onSendEmailRequestChange(false);
        updateEmailSuggestedText(data);
      })
      .catch((error) => {
        // Gérer l'erreur
        if (error.response) {
          // La requête a été reçue, mais le serveur a répondu avec un code d'erreur
          console.log(
            "// La requête a été reçue, mais le serveur a répondu avec un code d'erreur"
          );
          console.log(error.response.data);
          console.log(error.response.status);
          console.log(error.response.headers);
        } else if (error.request) {
          console.log(
            "// La requête a été envoyée, mais aucune réponse n'a été reçue"
          );
          console.log(error.request);
        } else {
          console.log(
            "// Une erreur est survenue lors de la création de la requête"
          );
          console.log("Erreur", error.message);
        }
        console.log(error.config);
        onInstructionRequestChange(false);
        onSendEmailRequestChange(false);
      });
  }

  const stringToColour = (str) => {
    let hash = 0;
    str.split("").forEach((char) => {
      hash = char.charCodeAt(0) + ((hash << 5) - hash);
    });
    let colour = "#";
    for (let i = 0; i < 3; i++) {
      const value = (hash >> (i * 8)) & 0xff;
      colour += value.toString(16).padStart(2, "0");
    }

    // Vérifiez si la couleur générée est dans la plage de jaune
    if (/^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(colour)) {
      const hexValue = colour.replace("#", "");
      const r = parseInt(hexValue.slice(0, 2), 16);
      const g = parseInt(hexValue.slice(2, 4), 16);
      const b = parseInt(hexValue.slice(4, 6), 16);

      // YELLOW
      if (r >= 200 && g >= 200 && b < 100) {
        colour = "#FF5733";
      }

      // WHITE
      const whiteThreshold = 200;
      if (r >= whiteThreshold && g >= whiteThreshold && b >= whiteThreshold) {
        colour = "#333333";
      }
    }

    return "#5E44FE";
  };

  function generateColor(text) {
    let hash = 0;
    // Calculer un code de hachage unique pour le texte
    for (let i = 0; i < text.length; i++) {
      hash = text.charCodeAt(i) + ((hash << 5) - hash);
    }

    // Générer une couleur hexadécimale à 6 caractères
    const color = "#" + ("000000" + (hash & 0xffffff).toString(16)).slice(-6);
    console.log("color is", color);

    return color;
  }

  function changeColor(tag) {
    switch (tag) {
      case "product":
        return "primary";
      case "product_availability":
        return "primary";
      case "product_advice":
        return "primary";
      case "product_problems":
        return "danger";
      case "product_price":
        return "primary";
      case "promotions":
        return "primary";
      case "order":
        return "danger";
      case "order_process":
        return "primary";
      case "payments":
        return "danger";
      case "refunds":
        return "danger";
      case "disputes":
        return "danger";
      case "billing":
        return "warning";
      case "delivery":
        return "danger";
      case "returns":
        return "warning";
      case "customer_account":
        return "info";
      case "password":
        return "info";
      case "security":
        return "info";
      case "privacy":
        return "info";
      case "customer_data":
        return "info";
      case "after_sales":
        return "info";
      case "technical_problems":
        return "primary";
      case "website_feedback":
        return "info";
      case "special_programs":
        return "info";
      case "affiliation":
        return "info";
      case "customer_loyalty":
        return "info";
      case "feedback":
        return "info";
      case "complaints":
        return "warning";
      case "company_information":
        return "info";
      case "ethics_social_responsibility":
        return "info";
      case "subscription_management":
        return "info";
      case "store_services":
        return "info";
      case "influencers":
        return "info";
      case "content_creators":
        return "info";
      case "spam":
        return "warning";
      case "other":
        return "info";
      default:
        return "warning";
    }
  }
  function cleanMessageId(messageId) {
    // Expression régulière pour capturer l'ID de message dans les chevrons <>
    const pattern = /<([^>]+)>/;
    // Enlever les caractères de retour à la ligne
    const cleanId = messageId.replace(/\r\n/g, "").trim();

    // Extraire la partie utile de l'ID de message
    const match = pattern.exec(cleanId);
    return match ? match[0] : cleanId;
  }

  const handleIconMouseEnter = (value, text) => {
    setHoverText([value, text]);
  };

  const handleIconMouseLeave = () => {
    setHoverText("");
  };

  function getMessageAssignation(theMessage) {
    let messageId = "";
    if (typeof theMessage.headers["message-id"] === "string") {
      messageId = theMessage.headers["message-id"];
    } else if (Array.isArray(theMessage.headers["message-id"])) {
      messageId = theMessage.headers["message-id"][0];
    }
    messageId = cleanMessageId(messageId);
    let name = "";

    if (props.client_data && messageInfos && messageInfos[messageId]) {
      // console.log("matching");

      const agents = props.client_data.agents.map((element) =>
        JSON.parse(element)
      );

      for (let i = 0; i < agents.length; i++) {
        if (agents[i].id === messageInfos[messageId].treated_by) {
          name =
            messageInfos[messageId].treated_by_ia === true &&
            messageInfos[messageId].process_state === "Treated" ? (
              <div style={{ display: "flex", alignItems: "end" }}>
                <div className="me-2">
                  {props.t("sent_by")} Synibox
                  {/* {agents[i].agent_name.map((name) => {
                    return name + " ";
                  })} */}
                </div>
                <div>
                  {/* <img
                    src={logo_smartas_1}
                    alt="aiButton__icon"
                    style={{
                      width: "auto",
                      height: "24px",
                      paddingLeft: "5px"
                    }}
                  /> */}
                </div>
              </div>
            ) : (
              <span>
                {props.t("sent_by")} {"---"}
              </span>
            );
          // console.log("match_name is", agents[i].agent_name);
        } else {
          console.log("no match agent");
        }
      }
    } else {
      console.log("no match");
    }
    return name;
  }

  const svgs = {
    info_icon: (
      <span
        className="pulse_red"
        style={{
          display: "flex",
          height: "20px",
          width: "20px",
          borderRadius: "100%"
        }}
      >
        <InfoMono width={"20px"} height={"20px"} />
      </span>
    )
  };

  function formaterDate(dateStr) {
    // const messageDate = new Date(dateStr);
    // const currentDate = new Date();
    // const differenceInMilliseconds = currentDate - messageDate;
    // const differenceInDays = Math.floor(differenceInMilliseconds / (1000 * 60 * 60 * 24));

    // if (differenceInDays === 0) {
    //   return "Aujourd'hui";
    // } else if (differenceInDays === 1) {
    //   return 'Hier';
    // } else {
    //   return `${differenceInDays}j`;
    // }
    const messageDate = new Date(dateStr);
    const aujourdHui = new Date();

    const options = { hour: "numeric", minute: "numeric" };
    const heureMinute = new Intl.DateTimeFormat(
      props.i18n.language + "-" + props.i18n.language.toUpperCase(),
      options
    ).format(messageDate);

    // Vérifier si la date est la même que celle d'aujourd'hui
    if (messageDate.toDateString() === aujourdHui.toDateString()) {
      return `${heureMinute}`;
    }

    // Vérifier si la date est celle d'hier
    const hier = new Date(aujourdHui);
    hier.setDate(aujourdHui.getDate() - 1);
    if (messageDate.toDateString() === hier.toDateString()) {
      return `${props.t("Hier à")} ${heureMinute}`;
    }

    // Si la date est vieille de plusieurs jours, afficher la date sans l'année
    const optionsDate = { day: "numeric", month: "short" };
    const dateSansAnnee = new Intl.DateTimeFormat(
      props.i18n.language + "-" + props.i18n.language.toUpperCase(),
      optionsDate
    ).format(messageDate);
    const dateFormatee = dateSansAnnee.replace(/\b\w/g, (firstLetter) =>
      firstLetter.toUpperCase()
    );
    return `${dateFormatee} ${heureMinute}`;
  }

  async function getMessageInfos(messageID) {
    const client = new Client();
    const databases = new Databases(client, "default");
    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);
    return databases
      .listDocuments("default", "message", [
        Query.equal("company", localStorage.getItem("companyId")),
        Query.equal("conversation_id", messageID)
      ])
      .then(
        function (response) {
          var data = response.documents;
          return data[0];
        },
        function (error) {
          console.log(error); // Echec
          console.log("Failed to fetch message info:", error);
        }
      );
  }

  /*
  async function fetchMessageInfo(messageID) {
    try {
      // console.log("MKK Fetching message info for " + messageID);

      // Fetch additional info from API for given messageID
      const info = await getMessageInfos(messageID);
      if (info) {
        // console.log("MKK Message info got for " + messageID, {
        //   message_id: info.message_id,
        //   contact_reasons: info.contact_reasons,
        //   client_sentiment: info.client_sentiment,
        //   body: info.message_body,
        // });

        setMessageInfos((prevState) => ({
          ...prevState,
          [messageID]: info
        }));

        // messageInfos[info.message_id] = info;
      } else {
        console.log("MKK No messageInfos for " + messageID);
      }
    } catch (error) {
      console.log("MKK No messageInfos", error);
    }
  }

  const handleTopicsUpdate = (topics) => {
    setMessageInfos(topics);
  };


  function getMailsDatas(messages) {
    console.log("MKK entering getMailsDatas for messeage Info fetch");

    for (const the_element of messages) {
      // console.log({ MKK_the_message: the_element });
      // console.log({ MKK_the_message_header: fullMessage[message.directMessageId].headers["message-id"] });
      let messageId = "";
      if (the_element["headers"]) {
        if (typeof the_element.headers["message-id"] === "string") {
          messageId = the_element.headers["message-id"];
        } else if (Array.isArray(the_element.headers["message-id"])) {
          messageId = the_element.headers["message-id"][0];
        }

        if (!messageInfos[messageId]) {
          // console.log("MKK 1 Fetching message info for " + messageId);
          fetchMessageInfo(cleanMessageId(messageId));
        }
      } else {
        console.log("MKK No message header: ", the_element["headers"], the_element, messages);
      }
    }

    //const messgTopics = messageInfos;
    // handleTopicsUpdate(messgTopics);
  }

  useEffect(() => {
    if (fullMessage && fullMessage[message.directMessageId] && fullMessage[message.directMessageId] !== "waiting") {
      console.log("MKK MESSAGE IS ", fullMessage[message.directMessageId]);

      if (fullMessage[message.directMessageId].related_messages && fullMessage[message.directMessageId].related_messages.length > 0) {
        // const reversedList = [];
        // for (let i = message.related_messages.length - 1; i >= 0; i--) {
        //   reversedList.push(message.related_messages[i]);
        // }

        setRelatedMessages(fullMessage[message.directMessageId].related_messages);
      } else {
        setRelatedMessages([]);
      }

      let messages = [...(fullMessage[message.directMessageId].related_messages ?? [])];
      // messages = [...message];
      messages.push(fullMessage[message.directMessageId]);

      //  getEmailTreatmentStatus(fullMessage[message.directMessageId]);
      getMailsDatas(messages);
    }
  }, [fullMessage, fullMessageLoading]);
  */

  // New Editor
  const [customEditorState, setCustomEditorState] = useState(
    createEditorStateWithText(text)
  );
  const editorRef = useRef(null);

  const focusEditor = () => {
    editorRef.current.focus();
  };

  const handleFileSelect = () => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.onchange = (e) => {
      const file = e.target.files[0];
      console.log("Fichier sélectionné :", file);
    };
    fileInput.click();
  };

  // async function getEmailTreatmentStatus(theMessage) {
  //   const messageToReply =
  //     !theMessage.related_messages || theMessage.related_messages.length === 0
  //       ? theMessage
  //       : theMessage.related_messages[theMessage.related_messages.length - 1];

  //   let message_to_reply_id = "";
  //   if (typeof messageToReply.headers["message-id"] === "string") {
  //     message_to_reply_id = messageToReply.headers["message-id"];
  //   } else if (Array.isArray(messageToReply.headers["message-id"])) {
  //     message_to_reply_id = messageToReply.headers["message-id"][0];
  //   }

  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.listDocuments("default", "process_turn", [Query.equal("conversation_id", message_to_reply_id)]);

  //   promise.then(
  //     async function (response) {
  //       if (response.total > 0) {
  //         setMessageTreatmentStatus(true);
  //       } else {
  //         setMessageTreatmentStatus(false);
  //       }
  //       console.log({ message_to_reply_id_response: response });
  //     },
  //     function (error) {
  //       console.log({ error });
  //       console.log({ message_to_reply_id_error: error });
  //       setMessageTreatmentStatus(false);
  //     }
  //   );
  // }

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "end"
    });
  };

  // useEffect(scrollToBottom, [message]);

  const {
    subscription_credits,
    client_data,
    subscription,
    is_user_plan_active,
    userPlan
  } = useSelector((state) => {
    return {
      subscription: state.subscription.subscription,
      subscription_credits: state.subscription.subscriptionCredits,
      client_data: state.GeneralStateRedux.client_data,
      is_user_plan_active: state.subscription.isUserPlanActive,
      userPlan: state.subscription.userPlan
    };
  });

  const [aiImprovmentsDisabled, setAiImprovmentsDisabled] = useState({
    value: false,
    reason: ""
  });
  const [aiSuggestionDisabled, setAiSuggestionDisabled] = useState({
    value: false,
    reason: ""
  });

  useEffect(() => {
    if (
      !client_data ||
      ((!subscription || !is_user_plan_active || subscription.pause) &&
        userPlan !== "MAAIA_PLAN_DIRECT_WORLD")
    ) {
      console.log("setAiImprovmentsDisabled 2");
      setAiImprovmentsDisabled({
        reason: props.t("Aucun abonnement actif"),
        value: true
      });
    } else if (
      client_data &&
      subscription_credits - client_data.consumed_email_count < 0.25
    ) {
      console.log("setAiImprovmentsDisabled 3");
      setAiImprovmentsDisabled({
        reason: props.t("Crédit insuffisant"),
        value: true
      });
    } else if (!getText()) {
      console.log("setAiImprovmentsDisabled 1");
      setAiImprovmentsDisabled({
        reason: props.t("Aucun texte saisi"),
        value: true
      });
    } else {
      setAiImprovmentsDisabled({ value: false, reason: "" });
    }

    if (
      !client_data ||
      ((!subscription || !is_user_plan_active || subscription.pause) &&
        userPlan !== "MAAIA_PLAN_DIRECT_WORLD")
    ) {
      console.log("setAiSuggestionDisabled 2");
      setAiSuggestionDisabled({
        reason: props.t("Aucun abonnement actif"),
        value: true
      });
    } else if (
      client_data &&
      subscription_credits - client_data.consumed_email_count < 1
    ) {
      console.log("setAiSuggestionDisabled 3");
      setAiSuggestionDisabled({
        reason: props.t("Crédit insuffisant"),
        value: true
      });
    } else {
      setAiSuggestionDisabled({ value: false, reason: "" });
    }
  }, [subscription_credits, client_data, customEditorState]);

  const { freeTranslationLimit } = useSelector((state) => {
    return {
      freeTranslationLimit: state.subscription.freeTranslationLimit
    };
  });
  const free_translation_count = client_data?.free_translation_count || 0;

  useEffect(() => {
    if (messageInfos && messageInfos[message.directMessageId]) {
      if (messageInfos[message.directMessageId].ai_reply) {
        if (textEndRef.current) {
          textEndRef.current.scrollIntoView({ behavior: "smooth" });
        }
      }
    }
    console.log("zzz fetchMessageOrders");
    setTimeout(() => {
      props.fetchMessageOrders([message]);
    }, 3000);

    setTimeout(() => {
      props.fetchMessageOrders([message]);
    }, 5000);

    setTimeout(() => {
      props.fetchMessageOrders([message]);
    }, 10000);

    props.fetchMessageOrders([message]);
  }, [props.messageInfos, props.theMessage /* the_related_messages*/]);

  const getFilteredMessage = async () => {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const response = await databases.listDocuments("default", "message", [
      Query.equal("conversation_id", messageToProcess)
    ]);
    console.log({ responseDocs: response.documents });
    return response.documents;
  };

  // async function deleteEmailProcessData(messageId) {
  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   databases
  //     .deleteDocument("default", "message", messageId)
  //     .then(async (response) => {
  //       if (response) {
  //         toggleToast();
  //         setToastMessage({ header: props.t("Succès"), body: props.t("Cet e-mail sera traité à nouveau par Synibox"), key: "success" });
  //         let messages = [...(fullMessage[message.directMessageId].related_messages ?? [])];
  //         // messages = [...message];
  //         messages.push(fullMessage[message.directMessageId]);

  //         getMailsDatas(messages);
  //       }
  //     })
  //     .catch((error) => {
  //       // Handle the error
  //       console.log("Failed deleting process data", error);
  //     });
  // }

  async function deleteEmailProcessData() {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);
    setLoadingProcess(true);
    try {
      const deleted_client_infos = await databases.deleteDocument(
        "default",
        "message",
        messageToProcess
      );

      console.log({ responseDocs: deleted_client_infos });

      if (deleted_client_infos) {
        setLoadingProcess(true);
        toggleProcess();
        toggleToast();
        setToastMessage({
          header: props.t("Succès"),
          body: props.t("Cet e-mail sera traité à nouveau par Synibox"),
          key: "success"
        });

        messageInfos[message.directMessageId] = undefined;
        props.setMessageInfos(messageInfos);

        const the_message_infos_data = await getMailsDatas(
          messageInfos,
          message
        );
        props.setMessageInfos(the_message_infos_data);
      } else {
        setLoadingProcess(false);
        toggleProcess();
        toggleToast();
        setToastMessage({
          header: props.t("Échec"),
          body: props.t("Erreur inattendu, veuillez réessayer"),
          key: "danger"
        });
      }
    } catch (error) {
      console.log({ responseDocsError: error });
      setLoadingProcess(false);
      toggleProcess();
      toggleToast();
      setToastMessage({
        header: props.t("Échec"),
        body: props.t("Erreur inattendu, veuillez réessayer"),
        key: "danger"
      });
    }
  }

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };

  function toggleProcess() {
    setIsProcess(!isProcess);
  }

  function confirmProcessing(messageId) {
    setMessageToProcess(messageId);
    toggleProcess();
  }

  return (
    <React.Fragment>
      {!fullMessage || !fullMessage[message.directMessageId] ? (
        props.t("Chargement") + "..."
      ) : fullMessage[message.directMessageId] === "failed" ? (
        props.t("Échec de chargement")
      ) : (
        <div
          className="readEmailView_conatiner d-flex flex-column"
          style={{
            overflowY: "auto",
            height: "93.7vh",
            borderTopColor: "#dcdcdc",
            borderTopWidth: props.showReadEmailView ? "2px" : "0px",
            borderTopStyle: "solid",
            paddingTop: "20px",
            marginTop: "5px",
            paddingRight: "10px"
          }}
        >
          <div className="" style={{ flex: "1", overflow: "auto" }}>
            <Container fluid={true} style={{}}>
              <div
                className="position-fixed bottom-0 end-0 p-3"
                style={{ zIndex: "9999999" }}
              >
                <CustomToast
                  isOpen={toast}
                  toggle={toggleToast}
                  message={toastMessage}
                />
              </div>

              <Modal
                isOpen={isProcess}
                toggle={() => toggleProcess()}
                centered
                className="user-modal"
              >
                <ModalBody className="p-3">
                  <h4 className="font-primary">
                    {props.t("Traiter à nouveau")}
                  </h4>
                  <p className="text-muted">
                    {props.t(
                      "Voulez-vous que Synibox traite à nouveau ce message ?"
                    )}
                  </p>
                </ModalBody>
                <ModalFooter>
                  <div
                    className="hstack gap-2 justify-content-end"
                    style={{ width: "100%" }}
                  >
                    <button
                      type="button"
                      className="view-button"
                      style={{ color: "black", width: "100%" }}
                      onClick={() => toggleProcess()}
                    >
                      {props.t("Non")}
                    </button>
                    <button
                      type="button"
                      style={{ backgroundColor: "#563bff", width: "100%" }}
                      className="view-button center font-primary"
                      disabled={loadingProcess}
                      id="edit-btn"
                      onClick={() => deleteEmailProcessData()}
                    >
                      {loadingProcess ? (
                        <span
                          className="spinner-border spinner-border-sm me-2 font-primary"
                          role="status"
                          aria-hidden="true"
                        />
                      ) : (
                        props.t("Oui")
                      )}
                    </button>
                  </div>
                </ModalFooter>
              </Modal>
              {/* <Breadcrumbs title="Email" breadcrumbItem="Read Email" /> */}
              {/* SideBar */}
              {/* {
              state ? <Col xl={2} className="">
            </Col> : <div></div>
            } */}
              {/*   <div className="d-flex justify-content-center align-items-center" style={{ width: "fit-content", padding: "0px 10px", backgroundColor: "#FFEDBB", borderRadius: "15px", color: "black", border: "1px #FDD667 solid" }}>{message.subject}</div> */}
              <div style={{ marginBottom: "0px" }}>
                {/*   ///////////////////// START MAIN EMAIL AREA /////////////////////// */}

                {/* <div className="d-flex flex-wrap justify-content-between">
                <div className="btn-toolbar" role="toolbar">
                  <div className="btn-group me-2 mb-3">
                    <button
                      type="button"
                      className="btn btn-primary waves-light waves-effect"
                    >
                      <i className="fa fa-inbox"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary waves-light waves-effect"
                    >
                      <i className="fa fa-exclamation-circle"></i>
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary waves-light waves-effect"
                    >
                      <i className="far fa-trash-alt"></i>
                    </button>
                  </div>
                  <div className="btn-group me-2 mb-3">
                    <Dropdown
                      isOpen={folderbtn}
                      toggle={() => setfolderbtn(!folderbtn)}
                    >
                      <DropdownToggle className="btn" color="primary" caret>
                        <i className="fa fa-folder me-1"></i>{" "}
                        <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>Updates</DropdownItem>
                        <DropdownItem>Social</DropdownItem>
                        <DropdownItem>Team Manage</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
                <div
                  className="btn-toolbar justify-content-md-end"
                  role="toolbar"
                >
                  <div className="btn-group ms-md-2 mb-3">
                    <Dropdown isOpen={tagbtn} toggle={() => settagbtn(!tagbtn)}>
                      <DropdownToggle className="btn" color="primary" caret>
                        <i className="fa fa-tag me-1"></i>{" "}
                        <i className="mdi mdi-chevron-down" />
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>Updates</DropdownItem>
                        <DropdownItem>Social</DropdownItem>
                        <DropdownItem>Team Manage</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                  <div className="btn-group ms-2 mb-3">
                    <Dropdown
                      isOpen={menubtn}
                      toggle={() => setmenubtn(!menubtn)}
                    >
                      <DropdownToggle className="btn" color="primary" caret>
                        More <i className="mdi mdi-dots-vertical ms-1"></i>{" "}
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem>Mark as Unread</DropdownItem>
                        <DropdownItem>Mark as Important</DropdownItem>
                        <DropdownItem>Add to Tasks</DropdownItem>
                        <DropdownItem>Add Star</DropdownItem>
                        <DropdownItem>Mute</DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </div> */}
                <div>
                  {/* <Card className="mb-0">
                  <CardBody> */}
                  {/* <div className="d-flex mb-4">
                      <div className="flex-shrink-0 me-3">
                        <Badge color="primary" className="rounded-circle avatar-sm" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          {(message.from.value[0].address ?? message.from.value[0].name)
                            .split(' ')
                            .map(part => part.charAt(0).toUpperCase())
                            .join('').slice(0, 2)}
                        </Badge>
                      </div>
                      <div className="flex-grow-1">
                        <h4 className="font-size-16">
                          {message.from.value[0].name}
                        </h4>
                        <p className="text-muted font-size-13">
                          {message.from.value[0].address}
                        </p>
                      </div>
                    </div> */}
                  {/* <h4 className="font-size-16">{message.subject}</h4> */}
                  {/*
                      <div
                        dangerouslySetInnerHTML={{ __html: message.body.html }}
                      />
                    */}

                  <div
                    className="mb-4 d-flex"
                    style={{
                      flexWrap: "nowrap",
                      marginLeft: "0px",
                      marginRight: "Opx"
                    }}
                  >
                    {/* <Col
                    // xl={1}
                    className="d-flex justify-content-center align-items-end col-xl-auto"
                    style={{
                      marginBottom: "26px",
                      // paddingLeft: "4%",
                      position: "relative",
                      padding: "0",
                    }}>
                    <div>
                      <div
                        color={changeColor(message.from.value[0].name)}
                        className="align-middle badge"
                        style={{
                          backgroundColor: "rgba(9, 27, 61, 0.5)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          borderRadius: "36px",
                          height: "36px",
                          width: "36px",
                          padding: "6px",
                          marginRight: "13px",
                        }}>
                        {(message.from.value[0].address ?? message.from.value[0].name)
                          .split(" ")
                          .map((part) => part.charAt(0).toUpperCase())
                          .join("")
                          .slice(0, 2)}
                      </div>
                    </div>
                  </Col> */}
                    <Col
                      xl={12}
                      className=""
                      style={{ paddingRight: "5%", paddingLeft: "0" }}
                    >
                      {fullMessage &&
                      fullMessage[message.directMessageId] &&
                      translatedMessages[
                        fullMessage[message.directMessageId].directMessageId
                      ] ? (
                        <>
                          <pre
                            className="bubble-bg-color-inner font-primary mb-0"
                            style={{
                              whiteSpace: "preserve"
                            }}
                          >
                            {translatedMessages[
                              fullMessage[message.directMessageId]
                                .directMessageId
                            ]
                              ? translatedMessages[
                                  fullMessage[message.directMessageId]
                                    .directMessageId
                                ]
                              : fullMessage[message.directMessageId].body.text}
                          </pre>

                          <p
                            className="font-size-12"
                            style={{
                              float: "left",
                              padding: "0px",
                              marginTop: "10px",
                              marginBottom: "0",
                              font: "normal 400 12px/normal Poppins, sans-serif",
                              color: "#758A89",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            {" "}
                            {formaterDate(
                              fullMessage[message.directMessageId].attributes
                                .date
                            )}
                          </p>
                          {MessageTagUI(
                            messageInfos,
                            fullMessage[message.directMessageId],
                            stringToColour,
                            handleIconMouseEnter,
                            handleIconMouseLeave,
                            props,
                            svgs,
                            tooltip,
                            setTooltip,
                            setTranslatedMessages,
                            translatedMessagesLoading,
                            setTranslatedMessagesLoading,
                            translatedMessages[
                              fullMessage[message.directMessageId]
                                .directMessageId
                            ]
                              ? true
                              : false,
                            false,
                            props.incrementAttr,
                            freeTranslationLimit,
                            free_translation_count
                          )}
                        </>
                      ) : fullMessage &&
                        fullMessage[message.directMessageId] &&
                        fullMessage[message.directMessageId].body.html ? (
                        <>
                          <div className="bubble-bg-color-inner font-primary">
                            {/* <div
                            dangerouslySetInnerHTML={{
                              __html: message.body.html,
                            }}
                          /> */}
                            <EmailContent
                              htmlContent={
                                fullMessage[message.directMessageId].body.html
                              }
                            />
                          </div>
                          <p
                            className="font-size-12"
                            style={{
                              float: "left",
                              padding: "0px",
                              marginTop: "3px",
                              marginBottom: "0",
                              font: "normal 400 12px/normal Poppins, sans-serif",
                              color: "#758A89",
                              overflow: "hidden",
                              textOverflow: "ellipsis"
                            }}
                          >
                            <div className="d-flex">
                              {formaterDate(
                                fullMessage[message.directMessageId].attributes
                                  .date
                              )}
                              {messageInfos &&
                                fullMessage[message.directMessageId] &&
                                messageInfos[message.directMessageId] &&
                                messageInfos[message.directMessageId]
                                  .failure_reason && (
                                  <div
                                    className="badge d-flex align-items-center py-1 px-2 ms-3"
                                    style={{
                                      borderRadius: "10px",
                                      backgroundColor: "#5e44fe",
                                      color: "white",
                                      fontSize: "10px",
                                      width: "fit-content",
                                      cursor: "pointer",
                                      marginTop: "1px"
                                    }}
                                    onClick={() => {
                                      confirmProcessing(
                                        messageInfos[message.directMessageId]
                                          .$id
                                      );
                                    }}
                                  >
                                    {props.t("Traiter à nouveau")}
                                  </div>
                                )}
                            </div>
                          </p>

                          {MessageTagUI(
                            messageInfos,
                            fullMessage[message.directMessageId],
                            stringToColour,
                            handleIconMouseEnter,
                            handleIconMouseLeave,
                            props,
                            svgs,
                            tooltip,
                            setTooltip,
                            setTranslatedMessages,
                            translatedMessagesLoading,
                            setTranslatedMessagesLoading,
                            translatedMessages[
                              fullMessage[message.directMessageId]
                                .directMessageId
                            ]
                              ? true
                              : false,
                            false,
                            props.incrementAttr,
                            freeTranslationLimit,
                            free_translation_count
                          )}
                        </>
                      ) : (
                        fullMessage &&
                        fullMessage[message.directMessageId] && (
                          <>
                            <pre
                              className="bubble-bg-color-inner font-primary mb-0"
                              style={{
                                whiteSpace: "preserve"
                              }}
                            >
                              {translatedMessages[
                                fullMessage[message.directMessageId]
                                  .directMessageId
                              ]
                                ? translatedMessages[
                                    fullMessage[message.directMessageId]
                                      .directMessageId
                                  ]
                                : fullMessage[message.directMessageId].body
                                    .text}
                            </pre>

                            <p
                              className="font-size-12"
                              style={{
                                float: "left",
                                padding: "0px",
                                marginTop: "12px",
                                marginBottom: "0",
                                font: "normal 400 12px/normal Poppins, sans-serif",
                                color: "#758A89",
                                overflow: "hidden",
                                textOverflow: "ellipsis"
                              }}
                            >
                              {" "}
                              {formaterDate(
                                fullMessage[message.directMessageId].attributes
                                  .date
                              )}
                            </p>
                            {MessageTagUI(
                              messageInfos,
                              fullMessage[message.directMessageId],
                              stringToColour,
                              handleIconMouseEnter,
                              handleIconMouseLeave,
                              props,
                              svgs,
                              tooltip,
                              setTooltip,
                              setTranslatedMessages,
                              translatedMessagesLoading,
                              setTranslatedMessagesLoading,
                              translatedMessages[
                                fullMessage[message.directMessageId]
                                  .directMessageId
                              ]
                                ? true
                                : false,
                              false,
                              props.incrementAttr,
                              freeTranslationLimit,
                              free_translation_count
                            )}
                          </>
                        )
                      )}
                    </Col>
                  </div>

                  {!messageInfos ? (
                    <div
                      style={{
                        textAlign: "center",
                        fontSize: "14px",
                        marginTop: "75px",
                        marginBottom: "75px"
                      }}
                    >
                      <Spinner
                        className="me-1"
                        style={{ height: "15px", width: "15px" }}
                        animation="border"
                      />
                      {props.t("Chargement") + "..."}
                    </div>
                  ) : (
                    messageInfos &&
                    messageInfos[message.directMessageId] &&
                    messageInfos[message.directMessageId].ai_reply && (
                      <div
                        className="d-flex"
                        style={{
                          flexWrap: "nowrap",
                          marginLeft: "0px",
                          marginRight: "Opx"
                        }}
                      >
                        <Col
                          xl={12}
                          className=""
                          style={{
                            paddingRight: "0",
                            paddingLeft: "5%",
                            marginBottom: "10px"
                          }}
                        >
                          <div
                            className="bubble-bg-color-outer font-primary mb-0"
                            style={
                              {
                                //  whiteSpace: "preserve"
                              }
                            }
                          >
                            <pre
                              style={{
                                whiteSpace: "preserve"
                              }}
                            >
                              {translatedMessages[message.messageId]
                                ? translatedMessages[message.messageId]
                                : messageInfos[message.directMessageId]
                                    .ai_reply}
                            </pre>
                            {/* <EmailContent
                              htmlContent={
                                translatedMessages[message.messageId]
                                  ? translatedMessages[message.messageId]
                                  : messageInfos[message.directMessageId].ai_reply
                              }
                            /> */}
                            {/* <div
                              dangerouslySetInnerHTML={{
                                __html: translatedMessages[message.messageId]
                                  ? translatedMessages[message.messageId].replace(/\n/g, "<br />")
                                  : messageInfos[message.directMessageId].ai_reply.replace(/\n/g, "<br />")
                              }}
                            /> */}
                          </div>

                          <div className="d-flex justify-content-between w-100">
                            <div className="reactions_container mt-2 ms-2 d-flex gap-2">
                              <svg
                                onClick={handleFeedBackOpen}
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ cursor: "pointer" }}
                                width="20"
                                height="20"
                                fill="rgb(117, 138, 137)"
                                viewBox="0 0 32 32"
                              >
                                <path d="M27 11h-8.52L19 9.8A6.42 6.42 0 0 0 13 1a1 1 0 0 0-.93.63L8.32 11H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h18.17a3 3 0 0 0 2.12-.88l3.83-3.83a3 3 0 0 0 .88-2.12V14a3 3 0 0 0-3-3zM4 28V14a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1zm24-3.83a1 1 0 0 1-.29.71l-3.83 3.83a1.05 1.05 0 0 1-.71.29H10V12.19l3.66-9.14a4.31 4.31 0 0 1 3 1.89 4.38 4.38 0 0 1 .44 4.12l-1 2.57A1 1 0 0 0 17 13h10a1 1 0 0 1 1 1z" />
                              </svg>
                              <svg
                                onClick={handleFeedBackOpen}
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ cursor: "pointer" }}
                                width="20"
                                height="20"
                                fill="rgb(117, 138, 137)"
                                viewBox="0 0 32 32"
                              >
                                <path d="m29.12 5.71-3.83-3.83A3 3 0 0 0 23.17 1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3.32l3.75 9.37A1 1 0 0 0 13 31a6.42 6.42 0 0 0 6-8.8l-.52-1.2H27a3 3 0 0 0 3-3V7.83a3 3 0 0 0-.88-2.12zM4 18V4a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1zm24 0a1 1 0 0 1-1 1H17a1 1 0 0 0-.93 1.37l1 2.57a4.38 4.38 0 0 1-.44 4.12 4.31 4.31 0 0 1-3 1.89L10 19.81V3h13.17a1 1 0 0 1 .71.29l3.83 3.83a1 1 0 0 1 .29.71z" />
                              </svg>
                            </div>
                            <div
                              className="font-size-12"
                              style={{
                                float: "right",
                                display: "flex",
                                alignItems: "end"
                              }}
                            >
                              {messageInfos[message.directMessageId] && (
                                <div
                                  className="me-2"
                                  style={{ alignItems: "end" }}
                                >
                                  {getMessageAssignation(
                                    fullMessage[message.directMessageId]
                                  )}
                                </div>
                              )}
                              {MessageTagUI(
                                messageInfos,
                                message,
                                stringToColour,
                                handleIconMouseEnter,
                                handleIconMouseLeave,
                                props,
                                svgs,
                                tooltip,
                                setTooltip,
                                setTranslatedMessages,
                                translatedMessagesLoading,
                                setTranslatedMessagesLoading,
                                translatedMessages[message.messageId]
                                  ? true
                                  : false,
                                true,
                                props.incrementAttr,
                                freeTranslationLimit,
                                free_translation_count
                              )}
                              <p
                                className="font-size-12"
                                style={{
                                  float: "right",
                                  padding: "0px",
                                  marginTop: "10px",
                                  marginBottom: "0",
                                  marginLeft: "10px",
                                  font: "normal 400 12px/normal Poppins, sans-serif",
                                  color: "#758A89",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis"
                                }}
                              >
                                {formaterDate(
                                  messageInfos[message.directMessageId]
                                    .$createdAt
                                )}
                              </p>
                            </div>
                          </div>
                        </Col>
                      </div>
                    )
                  )}

                  {/* {!sentMessage || !sentMessage[message.directMessageId] ? (
                    <div style={{ textAlign: "center", fontSize: "14px", marginTop: "75px", marginBottom: "75px" }}>
                      <Spinner className="me-1" style={{ height: "15px", width: "15px" }} animation="border" />
                      {props.t("Chargement") + "..."}
                    </div>
                  ) : sentMessage[message.directMessageId] === "failed" ? (
                    <div
                      style={{
                        textAlign: "center",
                        marginTop: "75px",
                        marginBottom: "75px"
                      }}>
                      <div
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          padding: "10px 10px 10px 10px",
                          border: "1px solid #f6f6f6",
                          borderRadius: "10px",
                          display: "inline-block"
                        }}>
                        {props.t("Échec de chargement")} <AlertTriangeMono width={"20px"} height={"20px"} style={{ color: "red" }} />
                      </div>
                    </div>
                  ) : (
                    sentMessage[message.directMessageId].map((sent_message, sentM_index) => (
                      <div
                        className="d-flex"
                        style={{
                          flexWrap: "nowrap",
                          marginLeft: "0px",
                          marginRight: "Opx"
                        }}>
                        <Col
                          xl={12}
                          className=""
                          style={{
                            paddingRight: "0",
                            paddingLeft: "5%",
                            marginBottom: "10px"
                          }}>
                          {sent_message.body.html ? (
                            <div
                              className="bubble-bg-color-outer font-primary mb-0"
                              style={
                                {
                                  //   whiteSpace: "preserve"
                                }
                              }>
                              <EmailContent
                                htmlContent={
                                  translatedMessages[sent_message.messageId] ? translatedMessages[sent_message.messageId] : sent_message.body.html
                                }
                              />
                              
                            </div>
                          ) : (
                            <div
                              style={
                                {
                                  //   whiteSpace: "preserve"
                                }
                              }>
                              {sent_message.body.text}
                            </div>
                          )}

                          <div className="d-flex justify-content-between w-100">
                            <div className="reactions_container mt-2 ms-2 d-flex gap-2">
                              <svg
                                onClick={handleFeedBackOpen}
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ cursor: "pointer" }}
                                width="20"
                                height="20"
                                fill="rgb(117, 138, 137)"
                                viewBox="0 0 32 32">
                                <path d="M27 11h-8.52L19 9.8A6.42 6.42 0 0 0 13 1a1 1 0 0 0-.93.63L8.32 11H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h18.17a3 3 0 0 0 2.12-.88l3.83-3.83a3 3 0 0 0 .88-2.12V14a3 3 0 0 0-3-3zM4 28V14a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1zm24-3.83a1 1 0 0 1-.29.71l-3.83 3.83a1.05 1.05 0 0 1-.71.29H10V12.19l3.66-9.14a4.31 4.31 0 0 1 3 1.89 4.38 4.38 0 0 1 .44 4.12l-1 2.57A1 1 0 0 0 17 13h10a1 1 0 0 1 1 1z" />
                              </svg>
                              <svg
                                onClick={handleFeedBackOpen}
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ cursor: "pointer" }}
                                width="20"
                                height="20"
                                fill="rgb(117, 138, 137)"
                                viewBox="0 0 32 32">
                                <path d="m29.12 5.71-3.83-3.83A3 3 0 0 0 23.17 1H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h3.32l3.75 9.37A1 1 0 0 0 13 31a6.42 6.42 0 0 0 6-8.8l-.52-1.2H27a3 3 0 0 0 3-3V7.83a3 3 0 0 0-.88-2.12zM4 18V4a1 1 0 0 1 1-1h3v16H5a1 1 0 0 1-1-1zm24 0a1 1 0 0 1-1 1H17a1 1 0 0 0-.93 1.37l1 2.57a4.38 4.38 0 0 1-.44 4.12 4.31 4.31 0 0 1-3 1.89L10 19.81V3h13.17a1 1 0 0 1 .71.29l3.83 3.83a1 1 0 0 1 .29.71z" />
                              </svg>
                            </div>
                            <div
                              className="font-size-12"
                              style={{
                                float: "right",
                                display: "flex",
                                alignItems: "end"
                              }}>
                              {messageInfos[fullMessage[message.directMessageId].directMessageId] && (
                                <div className="me-2" style={{ alignItems: "end" }}>
                                  {getMessageAssignation(fullMessage[message.directMessageId])}
                                </div>
                              )}
                              {MessageTagUI(
                                messageInfos,
                                sent_message,
                                stringToColour,
                                handleIconMouseEnter,
                                handleIconMouseLeave,
                                props,
                                svgs,
                                tooltip,
                                setTooltip,
                                setTranslatedMessages,
                                translatedMessagesLoading,
                                setTranslatedMessagesLoading,
                                translatedMessages[sent_message.messageId] ? true : false,
                                true,
                                props.incrementAttr,
                                freeTranslationLimit,
                                free_translation_count
                              )}
                              <p
                                className="font-size-12"
                                style={{
                                  float: "right",
                                  padding: "0px",
                                  marginTop: "10px",
                                  marginBottom: "0",
                                  font: "normal 400 12px/normal Poppins, sans-serif",
                                  color: "#758A89",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis"
                                }}>
                                {formaterDate(sent_message.attributes.date)}
                              </p>
                            </div>
                          </div>
                        </Col>
                
                      </div>
                    ))
                  )} */}
                  <div ref={textEndRef}></div>
                </div>

                {/*   ///////////////////// END MAIN EMAIL AREA /////////////////////// */}
              </div>

              <Modal
                isOpen={modal_backdrop}
                toggle={() => {
                  togModalVisibility();
                }}
                id="firstmodal"
              >
                <div className="modal-header">
                  <h5 className="modal-title" id="myModalLabel">
                    Succès
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => {
                      setModalVisibility(false);
                    }}
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div className="modal-body">
                  <p>Votre message est envoyé !</p>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-light"
                    onClick={() => {
                      setModalVisibility();
                    }}
                  >
                    Okay
                  </button>
                </div>
              </Modal>
              <Feedback
                isModalOpen={moveToModal}
                onClose={handleFeedbackClose}
              />
            </Container>
            <div ref={messagesEndRef} />
          </div>
          {/*   ///////////////////// reply-email-area /////////////////////// */}
          {!the_folder.toLowerCase().includes("sent") && (
            <div
              style={{
                position: "relative"
              }}
            >
              {messageTreatmentStatus && (
                <div
                  className="w-100 d-flex align-items-center justify-content-center"
                  style={{
                    zIndex: 9999999,
                    position: "absolute",
                    height: "calc(100% - 16px)"
                  }}
                >
                  <span
                    className="d-flex p-2"
                    style={{
                      color: "#F5AE00",
                      backgroundColor: "#FFF3D4",
                      borderRadius: "4px",
                      border: "1px solid #FFDF8E"
                    }}
                  >
                    <AlertTriangeMono
                      width={"20px"}
                      height={"20px"}
                      className="me-2"
                    />
                    {props.t(
                      "SMARTAS analyse actuellement cet email, veuillez patienter..."
                    )}
                  </span>
                </div>
              )}
              <Col xl={12} className="mb-3">
                <div
                  className="w-100"
                  style={
                    messageTreatmentStatus
                      ? {
                          position: "relative",
                          "-webkit-filter": "blur(4px)",
                          "-moz-filter": "blur(4px)",
                          "-o-filter": "blur(4px)",
                          "-ms-filter": "blur(4px)",
                          filter: "blur(4px)",
                          borderRadius: "10px",
                          pointerEvents: "none"
                        }
                      : {}
                  }
                >
                  <div
                    className="h-100"
                    style={{
                      display: messageTreatmentStatus ? "block" : "none",
                      backgroundColor: "#FEFCF3",
                      borderRadius: "10px",
                      position: "absolute",
                      width: "100%",
                      opacity: "0.8",
                      zIndex: "10"
                    }}
                  ></div>
                  <div className="grid-content">
                    <div className="grid-item">
                      <div className="editor-content">
                        <div
                          className="editor"
                          onClick={focusEditor}
                          style={{ paddingTop: "0", marginBottom: "0" }}
                        >
                          <Editor
                            placeholder={props.t("Tapez un Message")}
                            editorState={customEditorState}
                            onChange={(customEditorState) => {
                              setCustomEditorState(customEditorState);
                            }}
                            plugins={plugins}
                            ref={editorRef}
                            readOnly={messageTreatmentStatus}
                          />
                          <div className="custom-toolbar">
                            <Toolbar>
                              {
                                // may be use React.Fragment instead of div to improve perfomance after React 16
                                (externalProps) => (
                                  <div
                                    style={{
                                      paddingTop: "8px",
                                      paddingBottom: "8px",
                                      borderTop: "1px solid #E3E8E7",
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center"
                                    }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <BoldButton {...externalProps} />
                                      <ItalicButton {...externalProps} />
                                      <UnderlineButton {...externalProps} />
                                      {/* <CodeButton {...externalProps} />  */}
                                      <Separator {...externalProps} />
                                      <EmojiSelect />
                                      <EmojiSuggestions />
                                      <button
                                        className="fileChooser d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "36px",
                                          height: "34px",
                                          border: "none"
                                        }}
                                        onClick={handleFileSelect}
                                      >
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="15"
                                          height="17"
                                          viewBox="0 0 15 17"
                                          fill="none"
                                        >
                                          <path
                                            d="M14.3799 7.68305C14.438 7.7411 14.4841 7.81003 14.5156 7.8859C14.547 7.96178 14.5632 8.04311 14.5632 8.12524C14.5632 8.20738 14.547 8.28871 14.5156 8.36458C14.4841 8.44045 14.438 8.50939 14.3799 8.56743L7.96974 14.9737C7.14912 15.7942 6.03617 16.2551 4.87571 16.255C3.71526 16.255 2.60236 15.7939 1.78185 14.9733C0.961334 14.1527 0.500415 13.0397 0.500488 11.8793C0.500562 10.7188 0.961621 9.60591 1.78224 8.7854L9.53693 0.916649C10.1228 0.330168 10.9176 0.000439978 11.7466 4.39999e-07C12.5756 -0.000439098 13.3708 0.328446 13.9572 0.914305C14.5437 1.50016 14.8734 2.29501 14.8739 3.12398C14.8743 3.95295 14.5454 4.74814 13.9596 5.33462L6.20333 13.2034C5.85109 13.5556 5.37335 13.7535 4.87521 13.7535C4.37706 13.7535 3.89932 13.5556 3.54708 13.2034C3.19484 12.8511 2.99695 12.3734 2.99695 11.8752C2.99695 11.3771 3.19484 10.8994 3.54708 10.5471L10.0549 3.93618C10.1119 3.87537 10.1805 3.82657 10.2566 3.79266C10.3328 3.75876 10.415 3.74043 10.4983 3.73875C10.5816 3.73707 10.6645 3.75208 10.7419 3.7829C10.8194 3.81371 10.8899 3.85971 10.9493 3.91818C11.0087 3.97665 11.0558 4.04641 11.0879 4.12336C11.1199 4.20031 11.1362 4.2829 11.1359 4.36625C11.1355 4.44961 11.1185 4.53205 11.0858 4.60873C11.0531 4.68541 11.0054 4.75477 10.9455 4.81274L4.43693 11.4307C4.37865 11.4885 4.33233 11.5572 4.30062 11.633C4.26891 11.7087 4.25241 11.7899 4.25209 11.872C4.25176 11.9541 4.26761 12.0354 4.29872 12.1114C4.32983 12.1873 4.3756 12.2564 4.43341 12.3147C4.49122 12.373 4.55995 12.4193 4.63566 12.451C4.71137 12.4827 4.79259 12.4992 4.87467 12.4995C4.95676 12.4999 5.03811 12.484 5.11407 12.4529C5.19003 12.4218 5.25912 12.376 5.31739 12.3182L13.0729 4.45337C13.4251 4.10185 13.6233 3.62481 13.6238 3.12718C13.6243 2.62955 13.4271 2.15209 13.0756 1.79985C12.7241 1.44761 12.247 1.24944 11.7494 1.24892C11.2518 1.24841 10.7743 1.4456 10.4221 1.79712L2.66896 9.66274C2.37851 9.95273 2.14802 10.2971 1.99066 10.6761C1.83329 11.0552 1.75213 11.4615 1.7518 11.872C1.75148 12.2824 1.83199 12.6889 1.98875 13.0682C2.14552 13.4475 2.37546 13.7922 2.66544 14.0827C2.95543 14.3731 3.29978 14.6036 3.67884 14.761C4.0579 14.9183 4.46425 14.9995 4.87467 14.9998C5.2851 15.0001 5.69158 14.9196 6.07089 14.7629C6.4502 14.6061 6.79492 14.3762 7.08536 14.0862L13.4963 7.67993C13.6139 7.56322 13.7731 7.49799 13.9387 7.49858C14.1044 7.49916 14.2631 7.56552 14.3799 7.68305Z"
                                            fill="#272B35"
                                          />
                                        </svg>
                                      </button>
                                      <Separator {...externalProps} />
                                      {/* <button
                                      className="moreButton d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "36px",
                                        height: "34px",
                                        border: "none",
                                      }}>
                                      <svg xmlns="http://www.w3.org/2000/svg" width="6" height="17" viewBox="0 0 6 17" fill="none">
                                        <path
                                          d="M5.1875 8.4375C5.1875 8.87015 5.05921 9.29308 4.81884 9.65281C4.57848 10.0125 4.23683 10.2929 3.83712 10.4585C3.43741 10.6241 2.99757 10.6674 2.57324 10.583C2.14891 10.4986 1.75913 10.2902 1.45321 9.9843C1.14728 9.67837 0.938938 9.2886 0.854533 8.86426C0.770128 8.43993 0.813448 8.0001 0.979015 7.60038C1.14458 7.20067 1.42496 6.85903 1.78469 6.61866C2.14442 6.3783 2.56735 6.25 3 6.25C3.58016 6.25 4.13656 6.48047 4.5468 6.89071C4.95703 7.30094 5.1875 7.85734 5.1875 8.4375ZM3 4.375C3.43265 4.375 3.85558 4.24671 4.21531 4.00634C4.57504 3.76598 4.85542 3.42433 5.02099 3.02462C5.18655 2.62491 5.22987 2.18507 5.14547 1.76074C5.06106 1.33641 4.85273 0.946632 4.5468 0.640705C4.24087 0.334778 3.85109 0.126438 3.42676 0.0420332C3.00243 -0.042372 2.56259 0.000947807 2.16288 0.166515C1.76317 0.332081 1.42153 0.612459 1.18116 0.972191C0.940796 1.33192 0.812501 1.75485 0.812501 2.1875C0.812501 2.76766 1.04297 3.32406 1.45321 3.7343C1.86344 4.14453 2.41984 4.375 3 4.375ZM3 12.5C2.56735 12.5 2.14442 12.6283 1.78469 12.8687C1.42496 13.109 1.14458 13.4507 0.979015 13.8504C0.813448 14.2501 0.770128 14.6899 0.854533 15.1143C0.938938 15.5386 1.14728 15.9284 1.45321 16.2343C1.75913 16.5402 2.14891 16.7486 2.57324 16.833C2.99757 16.9174 3.43741 16.8741 3.83712 16.7085C4.23683 16.5429 4.57848 16.2625 4.81884 15.9028C5.05921 15.5431 5.1875 15.1201 5.1875 14.6875C5.1875 14.1073 4.95703 13.5509 4.5468 13.1407C4.13656 12.7305 3.58016 12.5 3 12.5Z"
                                          fill="#758A89"
                                        />
                                      </svg>
                                    </button> */}

                                      <div>
                                        <Dropdown
                                          isOpen={ai_action_menu}
                                          // disabled={props.client_data && props.client_data.plan_id && props.client_data.plan_id === "free"}
                                          toggle={() =>
                                            setAiActionMenu(!ai_action_menu)
                                          }
                                          className="user-dropdown d-inline-block "
                                        >
                                          <DropdownToggle
                                            className="p-0 bg-transparent border-0"
                                            id="ia-dropdown"
                                            tag="button"
                                          >
                                            <button
                                              className="aiButton d-flex align-items-center justify-content-center"
                                              style={{
                                                width: "36px",
                                                height: "34px",
                                                border: "none"
                                              }}
                                              // onClick={() => getAIResponse()}
                                              disabled={instruction_request}
                                            >
                                              {instruction_request ? (
                                                <span
                                                  className="spinner-border spinner-border-sm me-2"
                                                  role="status"
                                                  aria-hidden="true"
                                                ></span>
                                              ) : (
                                                <img
                                                  src={logo_smartas_1}
                                                  alt="aiButton__icon"
                                                  style={{
                                                    width: "auto",
                                                    height: "24px"
                                                  }}
                                                />
                                              )}
                                            </button>
                                          </DropdownToggle>
                                          <DropdownMenu
                                            className="font-primary simple-text px-2"
                                            style={{
                                              width: "25rem",
                                              textAlign: "start"
                                            }}
                                          >
                                            <div id="aiTextImprovement">
                                              <DropdownItem
                                                id="ImproveStyle"
                                                style={{
                                                  textAlign: "start",
                                                  cursor:
                                                    aiImprovmentsDisabled.value
                                                      ? "not-allowed"
                                                      : "pointer",
                                                  opacity:
                                                    aiImprovmentsDisabled.value
                                                      ? 0.65
                                                      : 1
                                                }}
                                                onClick={
                                                  !aiImprovmentsDisabled.value
                                                    ? () =>
                                                        getAiTextImprovement(
                                                          "styling"
                                                        )
                                                    : null
                                                }
                                              >
                                                <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                                  <i
                                                    className="mdi mdi-compass-rose"
                                                    style={{
                                                      color: "#272b35",
                                                      fontSize: "1.3rem"
                                                    }}
                                                  ></i>
                                                  <span
                                                    style={{
                                                      textAlign: "start",
                                                      fontSize: "1rem"
                                                    }}
                                                  >
                                                    {props.t("ImproveStyle")}
                                                  </span>
                                                </div>
                                              </DropdownItem>
                                              {aiImprovmentsDisabled.reason && (
                                                <UncontrolledTooltip
                                                  innerClassName="custom-inner-tooltip"
                                                  popperClassName="ms-2 custom-tooltip"
                                                  placement="right"
                                                  target={"ImproveStyle"}
                                                >
                                                  {aiImprovmentsDisabled.reason}
                                                </UncontrolledTooltip>
                                              )}
                                              <DropdownItem divider />

                                              <DropdownItem
                                                id="TranslateInputText"
                                                style={{
                                                  textAlign: "start",
                                                  cursor:
                                                    aiImprovmentsDisabled.value
                                                      ? "not-allowed"
                                                      : "pointer",
                                                  opacity:
                                                    aiImprovmentsDisabled.value
                                                      ? 0.65
                                                      : 1
                                                }}
                                                onClick={() =>
                                                  !aiImprovmentsDisabled.value
                                                    ? getAiTextImprovement(
                                                        "translation"
                                                      )
                                                    : null
                                                }
                                              >
                                                <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                                  <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    id="translate"
                                                  >
                                                    <path
                                                      fill="none"
                                                      d="M0 0h24v24H0V0z"
                                                    ></path>
                                                    <path d="M12.65 15.67c.14-.36.05-.77-.23-1.05l-2.09-2.06.03-.03c1.74-1.94 2.98-4.17 3.71-6.53h1.94c.54 0 .99-.45.99-.99v-.02c0-.54-.45-.99-.99-.99H10V3c0-.55-.45-1-1-1s-1 .45-1 1v1H1.99c-.54 0-.99.45-.99.99 0 .55.45.99.99.99h10.18C11.5 7.92 10.44 9.75 9 11.35c-.81-.89-1.49-1.86-2.06-2.88-.16-.29-.45-.47-.78-.47-.69 0-1.13.75-.79 1.35.63 1.13 1.4 2.21 2.3 3.21L3.3 16.87c-.4.39-.4 1.03 0 1.42.39.39 1.02.39 1.42 0L9 14l2.02 2.02c.51.51 1.38.32 1.63-.35zM17.5 10c-.6 0-1.14.37-1.35.94l-3.67 9.8c-.24.61.22 1.26.87 1.26.39 0 .74-.24.88-.61l.89-2.39h4.75l.9 2.39c.14.36.49.61.88.61.65 0 1.11-.65.88-1.26l-3.67-9.8c-.22-.57-.76-.94-1.36-.94zm-1.62 7l1.62-4.33L19.12 17h-3.24z"></path>
                                                  </svg>

                                                  <span
                                                    style={{
                                                      textAlign: "start",
                                                      fontSize: "1rem"
                                                    }}
                                                  >
                                                    {props.t(
                                                      "TranslateInputText"
                                                    )}
                                                  </span>
                                                </div>
                                              </DropdownItem>
                                              {aiImprovmentsDisabled.reason && (
                                                <UncontrolledTooltip
                                                  innerClassName="custom-inner-tooltip"
                                                  popperClassName="ms-2 custom-tooltip"
                                                  placement="right"
                                                  target={"TranslateInputText"}
                                                >
                                                  {aiImprovmentsDisabled.reason}
                                                </UncontrolledTooltip>
                                              )}
                                              <DropdownItem divider />

                                              <DropdownItem
                                                id="CorrectGrammar"
                                                style={{
                                                  textAlign: "start",
                                                  cursor:
                                                    aiImprovmentsDisabled.value
                                                      ? "not-allowed"
                                                      : "pointer",
                                                  opacity:
                                                    aiImprovmentsDisabled.value
                                                      ? 0.65
                                                      : 1
                                                }}
                                                onClick={() =>
                                                  !aiImprovmentsDisabled.value
                                                    ? getAiTextImprovement(
                                                        "grammar"
                                                      )
                                                    : null
                                                }
                                              >
                                                <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                                  <svg
                                                    width="24"
                                                    height="24"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M4 13L9 18L15 11.4545M20 6L17.25 9"
                                                      stroke="#272b35"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>

                                                  <span
                                                    style={{
                                                      textAlign: "start",
                                                      fontSize: "1rem"
                                                    }}
                                                  >
                                                    {props.t("CorrectGrammar")}
                                                  </span>
                                                </div>
                                              </DropdownItem>
                                              {aiImprovmentsDisabled.reason && (
                                                <UncontrolledTooltip
                                                  innerClassName="custom-inner-tooltip"
                                                  popperClassName="ms-2 custom-tooltip"
                                                  placement="right"
                                                  target={"CorrectGrammar"}
                                                >
                                                  {aiImprovmentsDisabled.reason}
                                                </UncontrolledTooltip>
                                              )}
                                              <DropdownItem divider />

                                              <DropdownItem
                                                id="Shorten"
                                                style={{
                                                  textAlign: "start",
                                                  cursor:
                                                    aiImprovmentsDisabled.value
                                                      ? "not-allowed"
                                                      : "pointer",
                                                  opacity:
                                                    aiImprovmentsDisabled.value
                                                      ? 0.65
                                                      : 1
                                                }}
                                                onClick={() =>
                                                  !aiImprovmentsDisabled.value
                                                    ? getAiTextImprovement(
                                                        "reduce"
                                                      )
                                                    : null
                                                }
                                              >
                                                <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                                  <svg
                                                    width="21"
                                                    height="21"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <path
                                                      d="M21 6H17M13 6H3M3 12H11M3 18H16"
                                                      stroke="#272b35"
                                                      strokeWidth="1.5"
                                                      strokeLinecap="round"
                                                    />
                                                  </svg>

                                                  <span
                                                    style={{
                                                      textAlign: "start",
                                                      fontSize: "1rem"
                                                    }}
                                                  >
                                                    {props.t("Shorten")}
                                                  </span>
                                                </div>
                                              </DropdownItem>
                                              {aiImprovmentsDisabled.reason && (
                                                <UncontrolledTooltip
                                                  innerClassName="custom-inner-tooltip"
                                                  popperClassName="ms-2 custom-tooltip"
                                                  placement="right"
                                                  target={"Shorten"}
                                                >
                                                  {aiImprovmentsDisabled.reason}
                                                </UncontrolledTooltip>
                                              )}
                                              <DropdownItem divider />
                                            </div>

                                            <DropdownItem
                                              id="aiTextSuggestion"
                                              style={{
                                                textAlign: "start",
                                                cursor:
                                                  aiSuggestionDisabled.value
                                                    ? "not-allowed"
                                                    : "pointer",
                                                opacity:
                                                  aiSuggestionDisabled.value
                                                    ? 0.65
                                                    : 1
                                              }}
                                              onClick={
                                                aiSuggestionDisabled.value
                                                  ? undefined
                                                  : getAIResponse
                                              }
                                            >
                                              <div className="d-flex justify-content-start flex-wrap gap-2 w-100">
                                                {/* <IconParkSolidRobotOne height="1.3rem" style={{ color: "#272b35" }} /> */}
                                                <img
                                                  src={logo_smartas_1}
                                                  alt="aiButton__icon"
                                                  style={{
                                                    width: "auto",
                                                    height: "24px",
                                                    paddingLeft: "5px",
                                                    filter: "grayscale(90%)"
                                                  }}
                                                />
                                                <span
                                                  style={{
                                                    textAlign: "start",
                                                    fontSize: "1rem"
                                                  }}
                                                >
                                                  {props.t("SuggestResponse")}
                                                </span>
                                              </div>
                                            </DropdownItem>
                                            {aiSuggestionDisabled.reason && (
                                              <UncontrolledTooltip
                                                innerClassName="custom-inner-tooltip"
                                                popperClassName="ms-2 custom-tooltip"
                                                placement="right"
                                                target={"aiTextSuggestion"}
                                              >
                                                {aiSuggestionDisabled.reason}
                                              </UncontrolledTooltip>
                                            )}
                                          </DropdownMenu>
                                        </Dropdown>
                                      </div>
                                    </div>
                                    <div className="sendEmail___button-container">
                                      <button
                                        className={`sendEmail___button ${
                                          send_email_request ? "disabled" : ""
                                        }`}
                                        onClick={() => sendEmail()}
                                      >
                                        {send_email_request ? (
                                          <span></span>
                                        ) : (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="20"
                                            height="22"
                                            viewBox="0 0 20 22"
                                            fill="none"
                                          >
                                            <path
                                              d="M20 10.9876C20.0007 11.2676 19.9253 11.5427 19.7814 11.7845C19.6376 12.0263 19.4306 12.2259 19.1819 12.3628L2.38813 21.7937C2.14685 21.9281 1.87438 21.9991 1.597 22C1.34121 21.9995 1.08926 21.9388 0.862293 21.8229C0.63532 21.7071 0.439933 21.5395 0.292509 21.3341C0.145084 21.1288 0.0499191 20.8918 0.0149899 20.643C-0.0199393 20.3941 0.0063857 20.1406 0.0917579 19.9038L2.8272 12.0504C2.85416 11.9727 2.90521 11.9052 2.9732 11.8575C3.04118 11.8097 3.12269 11.7841 3.20626 11.7842H10.3984C10.5081 11.7844 10.6167 11.7625 10.7174 11.7198C10.8181 11.6771 10.9088 11.6145 10.9838 11.5359C11.0588 11.4574 11.1166 11.3645 11.1536 11.263C11.1905 11.1616 11.2058 11.0538 11.1986 10.9463C11.1804 10.7442 11.0852 10.5563 10.932 10.4203C10.7788 10.2842 10.579 10.21 10.3724 10.2125H3.21327C3.12981 10.2127 3.0484 10.1872 2.98042 10.1396C2.91245 10.0921 2.86133 10.0248 2.8342 9.94731L0.0897575 2.08899C-0.0171174 1.78787 -0.0281984 1.46194 0.0579862 1.15449C0.144171 0.847039 0.323543 0.57261 0.572284 0.367645C0.821024 0.162679 1.12736 0.0368764 1.45062 0.00694133C1.77388 -0.0229937 2.09876 0.0443556 2.38213 0.200046L19.1849 9.61922C19.432 9.75589 19.6377 9.95462 19.781 10.1951C19.9242 10.4355 19.9998 10.709 20 10.9876Z"
                                              fill="#563BFF"
                                            />
                                          </svg>
                                        )}
                                      </button>
                                    </div>
                                  </div>
                                )
                              }
                            </Toolbar>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          )}
          {/*                 <div className="page-content">
                    <Container fluid={true}>
                        <Breadcrumbs title="Email" breadcrumbItem="Read Email" />
                        <Row className="mb-4">
                            <div className="col-xl-9">
                                <div className="d-flex flex-wrap justify-content-between">
                                    <div className="btn-toolbar" role="toolbar">
                                        <div className="btn-group me-2 mb-3">
                                            <button type="button" className="btn btn-primary waves-light waves-effect"><i className="fa fa-inbox"></i></button>
                                            <button type="button" className="btn btn-primary waves-light waves-effect"><i className="fa fa-exclamation-circle"></i></button>
                                            <button type="button" className="btn btn-primary waves-light waves-effect"><i className="far fa-trash-alt"></i></button>
                                        </div>
                                        <div className="btn-group me-2 mb-3">
                                            <Dropdown
                                                isOpen={folderbtn}
                                                toggle={() => setfolderbtn(!folderbtn)}
                                            >
                                                <DropdownToggle className="btn" color="primary" caret>
                                                    <i className="fa fa-folder me-1"></i>
                                                    {" "}
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem>Updates</DropdownItem>
                                                    <DropdownItem>Social</DropdownItem>
                                                    <DropdownItem>Team Manage</DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                    <div className="btn-toolbar justify-content-md-end" role="toolbar">
                                        <div className="btn-group ms-md-2 mb-3">
                                            <Dropdown
                                                isOpen={tagbtn}
                                                toggle={() => settagbtn(!tagbtn)}
                                            >
                                                <DropdownToggle className="btn" color="primary" caret>
                                                    <i className="fa fa-tag me-1"></i>
                                                    {" "}
                                                    <i className="mdi mdi-chevron-down" />
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem>Updates</DropdownItem>
                                                    <DropdownItem>Social</DropdownItem>
                                                    <DropdownItem>Team Manage</DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </div>
                                        <div className="btn-group ms-2 mb-3">
                                            <Dropdown
                                                isOpen={menubtn}
                                                toggle={() => setmenubtn(!menubtn)}
                                            >
                                                <DropdownToggle className="btn" color="primary" caret>
                                                    More <i className="mdi mdi-dots-vertical ms-1"></i>
                                                    {" "}
                                                </DropdownToggle>
                                                <DropdownMenu>
                                                    <DropdownItem>Mark as Unread</DropdownItem>
                                                    <DropdownItem>Mark as Important</DropdownItem>
                                                    <DropdownItem>Add to Tasks</DropdownItem>
                                                    <DropdownItem>Add Star</DropdownItem>
                                                    <DropdownItem>Mute</DropdownItem>
                                                </DropdownMenu>
                                            </Dropdown>
                                        </div>
                                    </div>
                                </div>
                                <Card className="mb-0">
                                    <CardBody>
                                        <div className="d-flex mb-4">
                                            <div className="flex-shrink-0 me-3">
                                                <img className="rounded-circle avatar-sm" src={img1} alt="Generic placeholder" />
                                            </div>
                                            <div className="flex-grow-1">
                                                <h4 className="font-size-16">{props.message.from.split("<")[0]}</h4>
                                                <p className="text-muted font-size-13">{props.message.from.split("<")[1].slice(0, -1)}</p>
                                            </div>
                                        </div>
                                        <h4 className="font-size-16">{props.message.subject}</h4>

                                        {props.message.body.text}
                                        <hr />

                                        <Row>
                                            <div className="col-xl-2 col-6">
                                                <Card>
                                                    <img className="card-img-top img-fluid" src={img3} alt="Card cap" />
                                                    <div className="py-2 text-center">
                                                        <Link to="#" className="fw-medium">Download</Link>
                                                    </div>
                                                </Card>
                                            </div>
                                            <div className="col-xl-2 col-6">
                                                <Card>
                                                    <img className="card-img-top img-fluid" src={img4} alt="Card cap" />
                                                    <div className="py-2 text-center">
                                                        <Link to="#" className="fw-medium">Download</Link>
                                                    </div>
                                                </Card>
                                            </div>
                                        </Row>

                                        <Link to="/compose-email" className="btn btn-secondary waves-effect mt-4"><i className="mdi mdi-reply"></i> Reply</Link>
                                    </CardBody>
                                </Card>
                            </div>
                        </Row>
                    </Container>
                </div> */}
        </div>
      )}
    </React.Fragment>
  );
};

export default withTranslation()(ReadEmail);

async function handleMessageTraduction(text, target_lang) {
  try {
    const response = await translateWithDeepLPromise(
      text,
      transformLangCodeToISO(target_lang)
    );
    const formatedResponse = JSON.parse(response);
    return formatedResponse.text;
  } catch (error) {
    console.log({ error });
    return null;
  }
}
function transformLangCodeToISO(langCode) {
  // Vérifie si le code de langue est "en" ou "pt" et transforme en code ISO adapté
  if (langCode === "en") {
    return "en-US";
  } else if (langCode === "pt") {
    return "pt-PT";
  } else {
    // Retourne le code de langue original si ce n'est ni "en" ni "pt"
    return langCode;
  }
}
function MessageTagUI(
  messageInfos,
  theMessage,
  stringToColour,
  handleIconMouseEnter,
  handleIconMouseLeave,
  props,
  svgs,
  tooltip,
  setTooltip,
  setTranslatedMessages,
  translatedMessagesLoading,
  setTranslatedMessagesLoading,
  isMessageTranlated = false,
  isSentMessage = false,
  incrementAttr,
  freeTranslationLimit,
  free_translation_count
) {
  return (
    <div
      className="font-primary"
      style={{ display: "flex", alignItems: "end", float: "right" }}
    >
      {isMessageTranlated ? (
        <div
          className="font-size-12"
          style={{
            cursor: "pointer"
          }}
          onClick={() => {
            setTranslatedMessages((prev) => {
              return {
                ...prev,
                [isSentMessage
                  ? theMessage.messageId
                  : theMessage.directMessageId]: null
              };
            });
          }}
        >
          {props.t("Voir l'original")}
        </div>
      ) : (
        <>
          <div
            id={"UncontrolledTooltip" + theMessage.messageId}
            className="font-size-12"
            style={{
              cursor: "pointer"
            }}
            onClick={async () => {
              setTranslatedMessagesLoading((prev) => {
                return {
                  ...prev,
                  [isSentMessage
                    ? theMessage.messageId
                    : theMessage.directMessageId]: true
                };
              });
              const trad = await handleMessageTraduction(
                messageInfos[theMessage.directMessageId].ai_reply,
                props.i18n.language
              );
              setTranslatedMessagesLoading((prev) => {
                return {
                  ...prev,
                  [isSentMessage
                    ? theMessage.messageId
                    : theMessage.directMessageId]: false
                };
              });
              if (trad) {
                incrementAttr();
                setTranslatedMessages((prev) => {
                  console.log({
                    translatedMessages: {
                      ...prev,
                      [isSentMessage
                        ? theMessage.messageId
                        : theMessage.directMessageId]: trad
                    }
                  });
                  return {
                    ...prev,
                    [isSentMessage
                      ? theMessage.messageId
                      : theMessage.directMessageId]: trad
                  };
                });
              }
            }}
          >
            {translatedMessagesLoading[
              isSentMessage ? theMessage.messageId : theMessage.directMessageId
            ] ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
            ) : (
              props.t("Voir la traduction")
            )}
          </div>
          <UncontrolledTooltip
            innerClassName="custom-inner-tooltip"
            popperClassName="ms-2 custom-tooltip"
            placement="top"
            target={"UncontrolledTooltip" + theMessage.messageId}
          >
            {`${props.t("Traduction gratuite consommée")}: ${
              free_translation_count < 10
                ? "0" + free_translation_count
                : free_translation_count
            }/${
              freeTranslationLimit < 10
                ? "0" + freeTranslationLimit
                : freeTranslationLimit
            }`}
          </UncontrolledTooltip>
        </>
      )}

      {!isSentMessage && (
        <div>
          {messageInfos[theMessage.directMessageId] &&
            messageInfos[theMessage.directMessageId].contact_reasons &&
            messageInfos[theMessage.directMessageId].contact_reasons.map(
              (reason, index) => (
                <div
                  key={index}
                  className={`badge ms-2 mt-2 font-primary`}
                  style={{
                    backgroundColor: `${stringToColour(reason)}25`,
                    color: stringToColour(reason),
                    font: "normal 400 11px / normal Poppins, sans-serif !important",
                    marginTop: "6px",
                    display: "flex !important"
                  }}
                >
                  {props.t(reason)}
                </div>
              )
            )}
        </div>
      )}
      {!isSentMessage && (
        <div className={`ms-2`}>
          {messageInfos[theMessage.directMessageId] &&
          messageInfos[theMessage.directMessageId].client_sentiment ===
            "neutral" ? (
            <img src={neutral} style={{ width: "20px" }} />
          ) : messageInfos[theMessage.directMessageId] &&
            messageInfos[theMessage.directMessageId].client_sentiment ===
              "happy" ? (
            <img src={love} style={{ width: "20px" }} />
          ) : messageInfos[theMessage.directMessageId] &&
            messageInfos[theMessage.directMessageId].client_sentiment ===
              "angry" ? (
            <img src={hate} style={{ width: "20px" }} />
          ) : null}
          {/* ) : null} */}
        </div>
      )}
      {!isSentMessage &&
        messageInfos[theMessage.directMessageId] &&
        messageInfos[theMessage.directMessageId].failure_reason && (
          <div>
            <Tooltip
              placement="top"
              isOpen={tooltip === "TooltipWithHtml" + theMessage.messageId}
              target={"TooltipWithHtml" + theMessage.messageId}
              toggle={() => {
                if (tooltip === "TooltipWithHtml" + theMessage.messageId) {
                  setTooltip(false);
                } else {
                  setTooltip("TooltipWithHtml" + theMessage.messageId);
                }
              }}
            >
              <span className="font-primary">
                {getLanguageVersion(
                  messageInfos[theMessage.directMessageId].failure_reason
                )}
              </span>
            </Tooltip>
            <div
              id={"TooltipWithHtml" + theMessage.messageId}
              style={{
                color: "red",
                cursor: "pointer"
              }}
              className="ms-2"
            >
              {svgs.info_icon}
              {/* {messageInfos[message.directMessageId].failure_reason} */}
            </div>
          </div>
        )}
    </div>
  );
}
